/* R2 Personalizer (DEV)
 * Ô1 = combobox tên có preview (gõ -> lọc). Ô2 = tên riêng (thiết kế riêng, no preview).
 * properties[Name] = hidden native, JS sync (custom ưu tiên). Vorschau = MODAL + nút Add-to-cart.
 */
(function () {
  /* 01/11 📷 photo3 HOOKS (V3 r3-photo.js dùng — KHÔNG XOÁ khi push bản local): keyX()/window.__r2pKeyX trong cartPrevKey + ck + _colorPrevCache + settle; window.__r2pKeyChanged; window.__r2pState (color/font/layout/name/paBox) — 2 global này CHỈ gắn trên trang V3. Trang V2: hook không tồn tại -> khoá y hệt cũ.
     01/11 ⌨️ live-typing (CHỈ V3 — shim có PodifyCanvas.v3.live): khối LIVE trong init (sau __r2pState, gồm thẻ xem trước mini «Live-Vorschau» trên điện thoại) + khối canvas «bản sống» trong setupGallery + composeOnColor trả khoá ảnh ghép cb(u, k). Trang V2: LIVE = false -> không gắn gì. KHÔNG XOÁ. */
  function slugify(s) {
    return (s || "").toLowerCase().trim()
      .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function esc(s) { return (s || "").replace(/[&<>]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]; }); }

  document.querySelectorAll("[data-r2p]").forEach(init);

  function init(root) {
    var cfg;
    try { cfg = JSON.parse(root.querySelector("[data-r2p-config]").textContent); } catch (e) { return; }
    var BASE = (cfg.base || "").replace(/\/$/, "");
    var design = cfg.design;
    var names = cfg.names || [];
    var TPL = cfg.tpl || {};
    var nameSlugs = {};
    function rebuildSlugs() { nameSlugs = {}; names.forEach(function (n) { nameSlugs[slugify(n)] = true; }); }
    rebuildSlugs();
    function fill(tpl, color, name) {
      var P = cfg.printArea || {};
      return (tpl || "")
        .replace(/{base}/g, BASE)
        .replace(/{design}/g, design || "")
        .replace(/{version}/g, cfg.version || "")
        .replace(/{garment}/g, cfg.garment || "")
        .replace(/{color}/g, color || "")
        .replace(/{slug}/g, slugify(name || ""))
        .replace(/{name}/g, encodeURIComponent(name || ""))
        .replace(/{pa_top}/g, P.top != null ? P.top : 31)
        .replace(/{pa_left}/g, P.left != null ? P.left : 33)
        .replace(/{pa_width}/g, P.width != null ? P.width : 34)
        .replace(/{pa_height}/g, P.height != null ? P.height : 26);
    }
    var pa = cfg.printArea || { top: 31, left: 33, width: 34, height: 26 };
    // 13/08: phôi ≠ t-shirt đặt render theo print_area ĐÃ CĂN (tab 🧵) — KHÔNG dùng res.tlw (suy từ place, hệ toạ độ t-shirt)
    var IS_TEE = !cfg.garment || cfg.garment === "tee" || cfg.garment === "t-shirt";
    var FLAT_CENTER_ON = true;   // 16/08 user BẬT LẠI neo giữa gối/túi (tắt 15/08 để tìm nguyên nhân — thủ phạm là hộp căn portal stretch, đã fix)
    var FLAT_CENTER = FLAT_CENTER_ON && (cfg.garment === "kissen" || cfg.garment === "tote-bag");   // phôi phẳng: design neo GIỮA khung (áo neo trên)
    var HAS_PA = !!(cfg.hasPA && cfg.printArea && typeof cfg.printArea.width === "number");   // hasPA = metafield THẬT (liquid), không phải fallback t-shirt

    var hidden = root.querySelector("[data-r2p-name]");
    var input = root.querySelector("[data-r2p-input]");      // ô tên DUY NHẤT (gõ tự do + lọc 500 tên)
    var list = root.querySelector("[data-r2p-list]");
    var caret = root.querySelector("[data-r2p-caret]");      // nút ▾ đóng/mở danh sách tên
    var previewBtn = root.querySelector("[data-r2p-preview-btn]");
    var status = root.querySelector("[data-r2p-status]");

    // ===== T1 multi-option: khách chọn font/layout (đọc PODIFY_CFG.config) =====
    var PCFG = window.PODIFY_CFG || {};
    var PCONF = PCFG.config || null;

    // ===== 29/08 LOẠI CUSTOM: 'name' (mặc định) | 'age' = NĂM SINH hoặc TUỔI gộp chung (chỉ chữ số, tối đa 4).
    // Cờ itype nằm trong personalizer_config (portal ghi lúc tạo SP). Property gửi giỏ VẪN là key 'Name'
    // (giá trị '1975'/'50') — toàn pipeline fulfillment/checkout-extension giữ nguyên, CHỈ đổi UI/validation.
    var ITYPE = (PCONF && PCONF.itype === "age") ? "age" : "name";
    var IS_AGE = ITYPE === "age";
    var MSG_EMPTY = IS_AGE ? "Bitte zuerst Jahrgang oder Alter eingeben" : "Bitte zuerst einen Namen eingeben";
    // ===== 15/10 NON-CUSTOM V3 «tên không bắt buộc»: cờ v3_config.nameOptional (portal tự suy từ template — input chính optional).
    // OPT=true: ô tên được BỎ TRỐNG ở mọi chốt (submit / express / mở xem trước / nút thêm giỏ của modal); trống -> xem trước,
    // _preview, lớp phủ gallery, thumb sticky = design KHÔNG tên (shim vẽ với ''), KHÔNG gửi properties[Name] (input disabled).
    // Thiếu cờ (mọi SP V2 / V3 hiện có) -> OPT=false -> mọi nhánh dưới chạy y hệt cũ.
    var OPT = !!(PCONF && PCONF.nameOptional === true);
    // 15/10 audit T-04: design loại năm sinh/tuổi (itype 'age') có chữ riêng; T-05: ghi chú KHÔNG còn bảo «oben» (ở trên) — dưới ghi chú có nút OPT_ADD mở ô nhập
    var OPT_NOTE = IS_AGE ? "✨ Vorschau ohne Jahrgang oder Alter – so wird dein Motiv gedruckt." : "✨ Vorschau ohne Namen – so wird dein Motiv gedruckt.";   // xem trước không năm sinh/tuổi | không tên – mẫu được in như thế này
    var OPT_STATUS = IS_AGE ? "Ohne Jahrgang oder Alter – Motiv wie abgebildet" : "Ohne Namen – Motiv wie abgebildet";   // không năm sinh/tuổi | không tên – in mẫu như hình
    var OPT_ADD = IS_AGE ? "✏️ Jahrgang oder Alter hinzufügen" : "✏️ Namen hinzufügen";   // nút trong hộp xem trước: thêm năm sinh/tuổi | thêm tên
    // 15/10 audit T-01: chụp r2p_state LÚC MỞ TRANG (chỉ OPT). Khách gõ rồi xoá hết tên -> trả lại đúng bản chụp (không có thì xoá key),
    // thay vì để lại chữ cái đầu (xoá từng ký tự) / tên vừa xoá (chọn hết + xoá) -> SP cá nhân hoá mở sau tự điền + mở khoá nút mua.
    var _lsOrig = null, _lsDirty = false;
    if (OPT) { try { _lsOrig = localStorage.getItem("r2p_state"); } catch (e) { _lsOrig = null; } }

    // ===== V2 canvas: mọi tên đều preview được -> TẮT gợi ý danh sách + GỠ cảnh báo, nhấn mạnh "mọi tên" =====
    var CANVAS = !!window.PodifyCanvas;
    if (CANVAS) {
      if (caret) caret.style.display = "none";
      if (list) list.hidden = true;
      if (input) {
        if (IS_AGE) { input.placeholder = "z.B. 1975 oder 50"; input.maxLength = 4; input.setAttribute("inputmode", "numeric"); input.setAttribute("pattern", "[0-9]*"); }
        else { input.placeholder = "Deinen Namen eingeben…"; input.maxLength = 30; }
      }
      var _badge = root.querySelector(".r2p__badge"); if (_badge) _badge.textContent = IS_AGE ? "Jahrgang oder Alter ✨" : "Jeder Name möglich ✨";
      var _hint = root.querySelector(".r2p__hint"); if (_hint) _hint.innerHTML = IS_AGE ? "💡 <strong>Jahrgang</strong> (z.B. 1975) oder <strong>Alter</strong> (z.B. 50) – nur Zahlen." : "💡 <strong>Jeder Name möglich</strong> – Buchstaben, Zahlen, Leerzeichen „ “ und Bindestrich „-“ können verwendet werden.";   // liệt kê ĐÚNG những gì cho phép
      if (OPT && !IS_AGE) {   // 15/10 tên không bắt buộc: placeholder + gợi ý "để trống = mẫu không tên"
        if (input) input.placeholder = "Name eingeben (optional)…";
        if (_hint) _hint.textContent = "💡 Leer lassen = Motiv ohne Namen. Ein Name wird genau wie in der Vorschau gedruckt.";   // audit T-08: để trống = mẫu không tên; tên (nếu nhập) được in đúng như bản xem trước
      }
      if (OPT && IS_AGE) {   // 15/10 audit T-04: năm sinh/tuổi không bắt buộc
        if (input) input.placeholder = "z.B. 1975 oder 50 (optional)";   // vd 1975 hoặc 50 (không bắt buộc)
        if (_hint) _hint.textContent = "💡 Leer lassen = Motiv ohne Jahrgang oder Alter. Nur Zahlen, z.B. 1975 oder 50.";   // để trống = mẫu không năm sinh/tuổi; chỉ chữ số, vd 1975 hoặc 50
      }
    }
    var fontOpts = (PCONF && PCONF.fonts && PCONF.fonts.length) ? PCONF.fonts : [{ id: PCFG.fontId, label: PCFG.fontId }];
    var layoutOpts = (PCONF && PCONF.layouts && PCONF.layouts.length) ? PCONF.layouts : [{ id: PCFG.layoutId, label: PCFG.layoutId }];
    var curFont = (PCONF && PCONF.fontDefault) || PCFG.fontId || (fontOpts[0] && fontOpts[0].id);
    var curLayout = (PCONF && PCONF.layoutDefault) || PCFG.layoutId || (layoutOpts[0] && layoutOpts[0].id);
    // ===== 03/08 STATE-CARRY: khôi phục tên/font/layout khách đã nhập — URL params (?pname/pfont/playout, cho link ads/switcher share) ƯU TIÊN hơn localStorage (điều hướng cùng browser).
    // Mọi giá trị đều VALIDATE với config của TRANG NÀY: font/layout lạ -> giữ default (SP anh em có thể thiếu layout); tên đi qua đúng pipeline sanitize như khách tự gõ. Không state -> không đổi gì.
    var _rs = null;
    try {
      var _q = new URLSearchParams(location.search);
      if (_q.get("pname") || _q.get("pfont") || _q.get("playout")) {
        _rs = { n: _q.get("pname") || "", f: _q.get("pfont") || "", l: _q.get("playout") || "" };
      } else {
        var _sv = JSON.parse(localStorage.getItem("r2p_state") || "null");
        if (_sv && (_sv.ty || "name") !== ITYPE) _sv = null;   // 29/08: state khác LOẠI custom (tên ↔ tuổi) -> không prefill chéo
        if (_sv && _sv.n && (Date.now() - (_sv.t || 0)) < 7 * 864e5) _rs = _sv;   // nhớ tối đa 7 ngày
        if (OPT && _rs) _rs = { n: "", f: _rs.f, l: _rs.l };   // 15/10 tên không bắt buộc: KHÔNG tự điền tên nhớ từ SP khác (khách vô tình mua CÓ tên) — font/design vẫn nhớ; ?pname (link ads) giữ nguyên
      }
    } catch (e) { _rs = null; }
    if (_rs) {
      if (_rs.f && fontOpts.some(function (o) { return o.id === _rs.f; })) curFont = _rs.f;
      if (_rs.l && layoutOpts.some(function (o) { return o.id === _rs.l; })) curLayout = _rs.l;
      if (_rs.n && input && !input.value) {
        // 22/08 PERF: tách 2 nhịp. (1) điền tên + syncHidden NGAY (rẻ, không mạng) -> khách thấy tên, form có prop.
        // (2) dispatch 'input' (pipeline nặng: atlas ~40 glyph + layout + mockup + render/upload preview ~500KB)
        // ĐỢI 'load' + idle — trước đây chạy ngay lúc trang đang tải nên mọi PDP của khách quay lại (và mỗi lần bấm
        // switcher phôi) đều kéo ~500KB đè lên LCP.
        setTimeout(function () {   // đợi init xong (listener input/warm đã gắn)
          // 26/08: sanitize NGAY ở nhịp 1 (BAD_STATIC var-hoisted, đã gán vì IIFE chạy đồng bộ xong trước setTimeout) —
          // ?pname/localStorage không còn được ghi THÔ vào properties[Name] trong cửa sổ chờ load+idle.
          try { input.value = String(_rs.n).replace(BAD_STATIC, "").slice(0, 30); syncHidden(); } catch (e) { /* */ }
        }, 0);
        var _rsFire = function () {
          // 26/08: input rỗng lúc này = khách ĐÃ CHỦ Ý xoá tên (nhịp 1 từng điền) -> tôn trọng, không hồi sinh tên cũ.
          try { if (!input.value) return; input.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) { /* */ }
        };
        var _rsIdle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 400); })(_rsFire, { timeout: 3000 }); };
        if (document.readyState === "complete") setTimeout(_rsIdle, 0); else window.addEventListener("load", _rsIdle, { once: true });
      }
    }
    // font/layout MẶC ĐỊNH luôn hiển thị ĐẦU danh sách picker
    function defFirst(opts, id) { return opts.filter(function (o) { return o.id === id; }).concat(opts.filter(function (o) { return o.id !== id; })); }
    fontOpts = defFirst(fontOpts, curFont); layoutOpts = defFirst(layoutOpts, curLayout);
    function _optLabel(opts, id) { for (var i = 0; i < opts.length; i++) if (opts[i].id === id) return opts[i].label || id; return id; }
    var R2BASE = (PCFG.r2 || "https://cdn.blazorastore.com").replace(/\/+$/, "");
    function renderOptPicker(opts, cur, grpSel, rowSel, onPick, thumbFn) {
      var grp = root.querySelector(grpSel), row = root.querySelector(rowSel);
      if (!grp || !row) return;
      if (!CANVAS || opts.length < 2) { grp.hidden = true; return; }   // 1 lựa chọn -> không hiện picker
      grp.hidden = false; row.innerHTML = "";
      opts.forEach(function (o) {
        var b = document.createElement("button"); b.type = "button"; b.className = "r2p__opt" + (o.id === cur ? " r2p--on" : ""); b.dataset.id = o.id;
        b.title = o.label || o.id;   // tooltip + a11y — KHÔNG hiện text (mã nội bộ vô nghĩa với khách), chỉ thumbnail
        var sp = document.createElement("span"); sp.className = "r2p__opt-txt"; sp.textContent = o.label || o.id;
        var tu = thumbFn ? thumbFn(o.id) : null;
        if (tu) {
          var im = document.createElement("img"); im.className = "r2p__opt-thumb"; im.alt = o.label || o.id; im.loading = "lazy";
          im.onerror = function () { im.remove(); b.appendChild(sp); };   // thumb lỗi -> fallback hiện tên
          im.src = tu; b.appendChild(im);
        } else b.appendChild(sp);
        b.addEventListener("click", function () {
          row.querySelectorAll(".r2p__opt").forEach(function (x) { x.classList.remove("r2p--on"); });
          b.classList.add("r2p--on"); onPick(o.id);
        });
        row.appendChild(b);
      });
    }
    function repaintIfOpen() { if (typeof paintModal === "function" && modal && !modal.hidden) paintModal(); }
    function updatePickerBg() { }   // nền chip = xám trung tính cố định (CSS), không đổi theo màu áo nữa
    // thumb bust theo NGÀY: layout/font up ĐÈ cùng mã -> URL không đổi -> cache cũ hiện thumb SAI (preview thì đúng vì có ?v manifest). Bust ngày = stale tối đa 24h, vẫn cache trong ngày.
    var _td = new Date(), THUMBV = _td.getUTCFullYear() * 10000 + (_td.getUTCMonth() + 1) * 100 + _td.getUTCDate();
    renderOptPicker(fontOpts, curFont, "[data-r2p-fontpick]", "[data-r2p-fontpick-row]", function (id) { curFont = id; syncHidden(); if (window.PodifyCanvas) window.PodifyCanvas.preload(curFont, curLayout); repaintIfOpen(); schedBgPreview(); sanitizeInput(); }, function (id) { return R2BASE + "/fonts/" + id + "/thumb.webp?v=" + THUMBV; });
    renderOptPicker(layoutOpts, curLayout, "[data-r2p-layoutpick]", "[data-r2p-layoutpick-row]", function (id) { curLayout = id; syncHidden(); if (window.PodifyCanvas) window.PodifyCanvas.preload(curFont, curLayout); repaintIfOpen(); schedBgPreview(); }, function (id) { return R2BASE + "/layouts/" + id + "/thumb.webp?v=" + THUMBV; });

    var injForms = [];
    var PROP_NAMES = ["Name", "_Schriftart", "_Design", "_srcdesign", "_preview", "_print", "_design", "_color", "_v"];   // _Schriftart/_Design: tiền tố _ để ẨN khỏi khách (cart/checkout/mail) nhưng VẪN lưu trong đơn cho fulfillment; _srcdesign = mã design GỐC V1 của layout khách chọn

    var modal = root.querySelector("[data-r2p-modal]");
    var mockEl = modal.querySelector("[data-r2p-mockup]");
    var overEl = modal.querySelector("[data-r2p-overlay]");
    var capEl = modal.querySelector("[data-r2p-customcap]");
    var noteEl = modal.querySelector("[data-r2p-modalnote]");
    var addBtn = modal.querySelector("[data-r2p-addcart]");
    var zModal = null;   // 04/10: bộ zoom con lăn của ảnh preview trong modal (gán ở attachZoom bên dưới)

    overEl.style.top = pa.top + "%"; overEl.style.left = pa.left + "%";
    overEl.style.width = pa.width + "%"; overEl.style.height = pa.height + "%";
    overEl.addEventListener("load", function () { overEl.style.visibility = "visible"; });
    overEl.addEventListener("error", function () {
      overEl.style.visibility = "hidden";
      // SELF-HEAL: overlay blob lỗi (vd bị revoke do race đổi font/layout nhanh) -> render lại (tối đa 2 lần)
      try { if (modal && !modal.hidden && (effectiveName() || OPT) && _ovHeal < 2) { _ovHeal++; showSpin(true); doCanvasRender(effectiveName(), curFont, curLayout, modalAfter(effectiveName())); } } catch (e) {}
    });

    // Spinner "đang tạo preview" — hết cảm giác đơ ở lần đầu (khi atlas đang tải từ R2).
    if (!document.getElementById("r2p-spin-css")) { var _sc = document.createElement("style"); _sc.id = "r2p-spin-css"; _sc.textContent = "@keyframes r2pspin{to{transform:rotate(360deg)}}"; document.head.appendChild(_sc); }
    var pvSpin = document.createElement("div");
    pvSpin.style.cssText = "position:absolute;inset:0;display:none;flex-direction:column;align-items:center;justify-content:center;gap:10px;font-size:14px;font-weight:600;color:#7a5c10;background:rgba(255,255,255,.78);z-index:5;pointer-events:none;text-align:center";
    pvSpin.innerHTML = '<span style="width:34px;height:34px;border:4px solid #eadfc0;border-top-color:#f26b21;border-radius:50%;animation:r2pspin .7s linear infinite;display:inline-block"></span><span>Vorschau wird erstellt…</span>';
    var pvStage0 = overEl.parentNode;
    if (pvStage0) { if (getComputedStyle(pvStage0).position === "static") pvStage0.style.position = "relative"; pvStage0.appendChild(pvSpin); }
    function showSpin(on) { pvSpin.style.display = on ? "flex" : "none"; }
    // Preload atlas SỚM: ngay khi gõ phím đầu / rê chuột vào nút preview -> atlas sẵn khi bấm.
    function warmPodify() {
      if (window.PodifyCanvas && window.PodifyCanvas.preload) window.PodifyCanvas.preload(curFont, curLayout);
      if (CANVAS && !warmPodify._d) {
        warmPodify._d = 1;
        try { var pc = document.createElement("link"); pc.rel = "preconnect"; pc.href = new URL(PREVIEW_EP).origin; document.head.appendChild(pc); } catch (e) {}   // TLS sớm cho upload
        try { var mw = new Image(); mw.crossOrigin = "anonymous"; var mu = mockUrl(currentColor); mw.src = mu + (mu.indexOf("?") >= 0 ? "&" : "?") + "cors=1"; } catch (e) {}   // warm phôi CORS cho composite
      }
    }
    input.addEventListener("input", warmPodify, { once: true });
    if (previewBtn) previewBtn.addEventListener("pointerenter", warmPodify);

    document.body.appendChild(modal);

    // A3: ẩn hàng option chỉ có 1 lựa chọn (vd "Verfügbares Produkt: T-Shirt") — tốn chỗ, không có gì để chọn
    try { document.querySelectorAll(".m-product-option").forEach(function (o) { if (o.querySelectorAll("input[type=radio]").length === 1 && !o.querySelector("select")) o.style.display = "none"; }); } catch (e) {}

    // A2: dòng tóm tắt biến thể trong modal (Size·Farbe) — chặn mua nhầm size mặc định; bấm -> về chỗ chọn
    var sumEl = document.createElement("button");
    sumEl.type = "button";
    sumEl.style.cssText = "display:block;width:100%;margin:0 0 8px;padding:8px 10px;border:1.5px dashed #d8dbe2;border-radius:8px;background:#fafafa;font-size:13px;color:#374151;cursor:pointer;text-align:center;line-height:1.4";
    if (addBtn && addBtn.parentNode) addBtn.parentNode.insertBefore(sumEl, addBtn);
    sumEl.addEventListener("click", function () {
      closeModal();
      var opts = document.querySelectorAll(".m-product-option");
      var tgt = null;
      opts.forEach(function (o) { if (!tgt && o.style.display !== "none" && o.querySelectorAll("input[type=radio]").length > 1 && !o.className.match(/color/)) tgt = o; });
      (tgt || root).scrollIntoView({ block: "center", behavior: "smooth" });
    });
    // 15/10 audit T-05 (CHỈ OPT): hộp xem trước bản không tên có nút phụ «✏️ Namen hinzufügen» (thêm tên) — đóng hộp, cuộn tới ô tên, đặt con trỏ vào ô
    // (trước đây ghi chú bảo «thêm tên ở phía trên» mà không có đường nào; mở từ thanh dính thì ô tên ở xa phía trên). SP thường: không tạo nút này.
    var addNameEl = null;
    if (OPT && noteEl && noteEl.parentNode) {
      addNameEl = document.createElement("button");
      addNameEl.type = "button";
      addNameEl.className = "r2p__addname";
      addNameEl.textContent = OPT_ADD;
      addNameEl.style.cssText = "display:none;width:100%;margin:10px 0 0;padding:11px 12px;min-height:44px;border:1.5px solid #cfd3da;border-radius:10px;background:#fff;color:#1f2937;font-size:14px;font-weight:700;line-height:1.3;cursor:pointer";
      noteEl.parentNode.insertBefore(addNameEl, noteEl.nextSibling);
      addNameEl.addEventListener("click", function () {
        closeModal();
        var cb = input.closest ? (input.closest(".r2p__combo") || input) : input;
        try { cb.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) {}
        try { input.focus({ preventScroll: true }); } catch (e) { try { input.focus(); } catch (e2) {} }   // gọi NGAY trong cú bấm -> điện thoại mở bàn phím
        if (cb.classList) { cb.classList.remove("r2p-flash"); void cb.offsetWidth; cb.classList.add("r2p-flash"); }   // nháy viền ô tên (CSS r2p-flash có sẵn)
      });
    }
    function updateVariantSummary() {
      var parts = [];
      document.querySelectorAll(".m-product-option input[type=radio]:checked").forEach(function (i) { if (i.value) parts.push(i.value); });
      sumEl.innerHTML = parts.length ? ("Deine Auswahl: <strong>" + esc(parts.join(" · ")) + "</strong> &nbsp;<span style=\"color:#1a6fd4;text-decoration:underline\">ändern</span>") : "";
      sumEl.style.display = parts.length ? "block" : "none";
    }

    // ===== gắn properties[Name] vào ĐÚNG (các) form Add-to-cart =====
    // form thật nằm trong <product-form> (nút chính + sticky); KHÔNG phải form .installment (Shop Pay)
    var realForms = [].slice.call(document.querySelectorAll("product-form form[action*='/cart/add']"));
    if (!realForms.length) {
      realForms = [].slice.call(document.querySelectorAll("form[action*='/cart/add']"))
        .filter(function (f) { return !f.classList.contains("installment"); });
    }
    function mkInjected(f, prop) {
      var safe = prop.replace(/[^a-z0-9_]/gi, "");
      var el = f.querySelector("input[data-r2p-prop='" + safe + "']");
      if (!el) {
        el = document.createElement("input");
        el.type = "hidden"; el.name = "properties[" + prop + "]";
        el.setAttribute("data-r2p-prop", safe);
        f.appendChild(el);
      }
      return el;
    }
    // ===== Klaviyo "Added to Cart Full": event tự bắn kèm TOÀN BỘ giỏ + _preview/Name =====
    // Event ATC chuẩn của Shopify không mang line properties -> email Cart không hiện ảnh tên khách.
    // Bắn sau khi submit THẬT đi qua (guard tên đã pass); đọc /cart.js sau 1.2s để Shopify kịp add.
    // Chỉ track, không đụng luồng bán; không có window.klaviyo (chưa consent cookie) -> bỏ qua êm.
    var __r2pAtcTs = 0;
    function fireAtcFull() {
      try {
        if (Date.now() - __r2pAtcTs < 1500) return;
        __r2pAtcTs = Date.now();
        setTimeout(function () {
          try {
            fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
              var kl = window.klaviyo;
              if (!kl || typeof kl.push !== "function" || !cart || !cart.items) return;
              var items = cart.items.map(function (i) {
                var p = i.properties || {};
                // 23/10 review T9: thêm year + type giống assets/blz-atc-full.js -> giỏ trộn (áo thiết kế tay + SP V2/V3) vẫn giữ type='manual' cho email Cart
                return {
                  title: i.product_title || "", variant: i.variant_title || "",
                  qty: i.quantity || 1, price: (i.final_price || 0) / 100,
                  name: p["Name"] || "", preview: p["_preview"] || "",
                  image: i.image || "", url: i.url ? ("https://blazorastore.com" + i.url) : "",
                  year: p["Jahrgang"] || "",
                  type: p["_type"] ? String(p["_type"]) : (p["_preview"] ? "preview" : (p["Name"] ? "name" : "none"))
                };
              });
              // Ghi gio vao PROFILE PROPERTY truoc (email doc luc GUI -> luon du gio moi nhat,
              // ke ca khach them nhieu mon sau khi da vao flow); event chi de TRIGGER flow.
              kl.push(["identify", {
                cart_items: items,
                cart_count: cart.item_count || items.length,
                cart_total: (cart.total_price || 0) / 100
              }]);
              kl.push(["track", "Added to Cart Full", {
                items: items, item_count: cart.item_count || items.length,
                total: (cart.total_price || 0) / 100, $value: (cart.total_price || 0) / 100
              }]);
            }).catch(function () { /* im lang */ });
          } catch (e2) { /* im lang */ }
        }, 1200);
      } catch (e1) { /* im lang */ }
    }
    realForms.forEach(function (f) {
      var map = {};
      PROP_NAMES.forEach(function (p) { map[p] = mkInjected(f, p); });
      injForms.push({ f: f, map: map });
      f.addEventListener("submit", function (e) {
        syncHidden();
        if (!effectiveName() && !OPT) {   // 15/10: SP tên không bắt buộc -> trống vẫn mua (ảnh _preview không tên chờ ở dưới)
          e.preventDefault(); e.stopImmediatePropagation();
          warn(MSG_EMPTY);
          root.scrollIntoView({ block: "center", behavior: "smooth" });
          input.focus();
          return;
        }
        if (f._r2pPass) { fireAtcFull(); return; }   // đã chờ ảnh xong -> cho theme xử lý tiếp (AJAX drawer)
        logName("atc");
        var v = effectiveName();
        // Tên CUSTOM (canvas) mà ảnh _preview CHƯA sẵn (khách add nhanh, upload ngầm chưa xong)
        // -> chặn tạm, ép upload ngay, tự submit lại khi xong (tối đa 4.5s — KHÔNG bao giờ chặn bán).
        if (CANVAS && window.PodifyCanvas && !previewable(slugify(v)) && !(canvasPrevUrl && canvasPrevKey === cartPrevKey(v))) {
          e.preventDefault(); e.stopImmediatePropagation();
          waitPreviewThenSubmit(f, v);
          return;
        }
        fireAtcFull();
      }, true);
    });
    var cartForm = realForms[0] || null;

    // form Shop Pay/installment (express checkout): gắn snippet hidden để carry tên; không có thì gỡ name tránh trùng
    var instForm = document.querySelector("form.installment[action*='/cart/add']");
    if (instForm) {
      var ifid = instForm.getAttribute("id");
      if (!ifid) { ifid = "r2p-inst-form"; instForm.setAttribute("id", ifid); }
      hidden.setAttribute("form", ifid);
    } else {
      hidden.removeAttribute("name");
    }

    // ===== CHẶN express checkout (Shop Pay/PayPal/Google Pay...) khi CHƯA nhập tên =====
    // Express bỏ qua giỏ + KHÔNG bắn submit (Shopify JS xử lý riêng) nên bẫy submit ở trên không bắt được.
    // => phủ lớp trong suốt bắt click; chưa có tên thì chặn + báo + cuộn lên ô tên; có tên thì gỡ chặn.
    var dynWraps = [].slice.call(document.querySelectorAll(".m-product-dynamic-checkout, .buy-one-click"));
    dynWraps.forEach(function (wrap) {
      if (wrap.__r2pGuard) return;
      if (getComputedStyle(wrap).position === "static") wrap.style.position = "relative";
      var g = document.createElement("div");
      g.className = "r2p-express-guard";
      g.setAttribute("aria-hidden", "true");
      g.style.cssText = "position:absolute;inset:0;z-index:6;cursor:pointer;background:transparent;";
      g.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        warn(MSG_EMPTY);
        root.scrollIntoView({ block: "center", behavior: "smooth" });
        input.focus();
      });
      wrap.appendChild(g);
      wrap.__r2pGuard = g;
    });
    function updateExpressGuard() {
      var block = !effectiveName() && !OPT;   // 15/10: tên không bắt buộc -> không phủ chặn mua nhanh
      dynWraps.forEach(function (wrap) {
        if (wrap.__r2pGuard) wrap.__r2pGuard.style.display = block ? "block" : "none";
      });
    }
    updateExpressGuard();

    var currentColor = slugify(cfg.defaultColor || "schwarz");

    function mockUrl(c) {
      if (TPL.mockup) return fill(TPL.mockup, c, "");
      return (cfg.mockups && cfg.mockups[c]) ? cfg.mockups[c] : BASE + "/mockups/" + c + ".webp";
    }
    function overlayUrl(slug) { return (cfg.overlays && cfg.overlays[slug]) ? cfg.overlays[slug] : BASE + "/designs/" + design + "/" + slug + ".png"; }
    function hasOverlay(slug) { return !!(slug && cfg.overlays && cfg.overlays[slug]); }
    function swapMockup() { if (currentColor) mockEl.src = mockUrl(currentColor); }
    // ảnh màu trong gallery (design trên áo, placeholder DEIN NAME) — cho tên riêng
    function galleryUrl(c) {
      if (cfg.colorImages && cfg.colorImages[c]) return cfg.colorImages[c];  // ảnh THẬT theo màu trong gallery
      if (TPL.gallery) return fill(TPL.gallery, c, "");
      if (TPL.mockup) return fill(TPL.mockup, c, "");                        // fallback: mockup phôi đúng màu (luôn tồn tại)
      return BASE + "/mockups/" + (cfg.garment || "") + "/" + (c || "") + ".webp";
    }

    // tên hiệu lực = giá trị ô duy nhất
    function effectiveName() {
      return (input.value || "").trim();
    }
    function previewable(slug) { if (CANVAS) return false; return !!nameSlugs[slug]; }     // V2 canvas: MỌI tên render canvas (bỏ phụ thuộc overlays 500 tên pre-gen); V1 cũ: tên trong list mới có preview sẵn
    function previewUrl() {
      var n = effectiveName(); if (!n) return "";
      var s = slugify(n); if (!previewable(s)) return "";
      if (TPL.preview) return fill(TPL.preview, currentColor, n);   // dynamic R2 (template có {version} → cache-bust)
      var m = cfg.composites && cfg.composites[s];                  // fallback demo
      return m ? (m[currentColor] || m.schwarz || m[Object.keys(m)[0]] || "") : "";
    }
    function printUrl() {
      var n = effectiveName(); if (!n) return "";
      if (!previewable(slugify(n))) return "";
      return TPL.print ? fill(TPL.print, currentColor, n) : "";
    }
    function propValue(p) {                          // mục 3: đủ tham số để tái tạo từ đơn hàng
      var n = effectiveName();
      if (p === "Name") return n;
      if (p === "_Schriftart") return CANVAS ? (curFont || "") : "";   // ID THẬT font khách chọn (không dùng label — label có thể bị đặt thành text bất kỳ); _ = ẩn khỏi khách
      if (p === "_Design") return CANVAS ? (curLayout || "") : "";     // ID THẬT layout khách chọn (mã design gốc của layout) — fulfillment đọc thẳng, kể cả SP nhiều layout phụ
      if (!n && !OPT) return "";   // 15/10: tên không bắt buộc + trống -> VẪN gửi _preview (ảnh ghép không tên) / _color / ... cho giỏ + fulfillment
      if (p === "_preview") { var pu = previewUrl(); if (pu) return pu; return (canvasPrevUrl && canvasPrevKey === cartPrevKey(n)) ? canvasPrevUrl : ""; }   // custom name: URL canvas đã up (đúng combo hiện tại)
      if (p === "_print") return printUrl();
      if (p === "_design") return cfg.design || "";
      if (p === "_srcdesign") { for (var si = 0; si < layoutOpts.length; si++) { if (layoutOpts[si].id === curLayout) return layoutOpts[si].src || cfg.design || ""; } return cfg.design || ""; }   // mã design GỐC V1 của layout đang chọn (config metafield layouts[].src, worker bơm từ manifest)
      if (p === "_color") return currentColor || "";
      if (p === "_v") return cfg.version || "";
      return "";
    }
    function syncHidden() {
      // 03/08 STATE-CARRY persist: lưu tên/font/layout vào localStorage mỗi lần đổi -> trang SP khác (kể cả listing anh em) tự prefill, khách không phải gõ lại
      try {
        if (!OPT || effectiveName()) { localStorage.setItem("r2p_state", JSON.stringify({ n: effectiveName(), f: curFont, l: curLayout, t: Date.now(), ty: ITYPE })); if (OPT) _lsDirty = true; }   // 15/10: SP tên không bắt buộc để trống -> KHÔNG ghi đè tên khách đã nhớ cho SP khác
        else if (_lsDirty) { _lsDirty = false; if (_lsOrig == null) localStorage.removeItem("r2p_state"); else localStorage.setItem("r2p_state", _lsOrig); }   // audit T-01: OPT gõ rồi xoá hết -> trả bản chụp lúc mở trang
      } catch (e) { /* */ }
      if (hidden.getAttribute("name")) hidden.value = effectiveName();   // form installment: chỉ Name
      if (OPT) hidden.disabled = !effectiveName();   // 15/10: trống -> không gửi Name rỗng
      injForms.forEach(function (g) {
        PROP_NAMES.forEach(function (p) { g.map[p].value = propValue(p); });
        if (OPT) g.map.Name.disabled = !effectiveName();   // 15/10: tên không bắt buộc + trống -> input disabled = KHÔNG vào form post / FormData (không gửi properties[Name] rỗng)
      });
      updateStatus();
      updateExpressGuard();
    }
    function updateStatus() {
      var v = effectiveName();
      status.classList.remove("r2p--warn", "r2p--ok", "r2p--info");
      if (!v && OPT) { status.classList.add("r2p--ok"); status.textContent = OPT_STATUS; return; }   // 15/10: tên không bắt buộc, trống = in mẫu không tên
      if (!v) { status.innerHTML = ""; return; }
      var nm = "<strong>„" + esc(v) + "“</strong>";
      if (CANVAS) {   // V2: mọi tên đều có preview -> chỉ xác nhận, KHÔNG cảnh báo
        status.classList.add("r2p--ok");
        status.innerHTML = "✓ " + nm + " – Sofort-Vorschau verfügbar";
        return;
      }
      if (previewable(slugify(v))) {
        status.classList.add("r2p--ok");
        status.innerHTML = "✓ " + nm + " – Sofort-Vorschau verfügbar";
      } else {
        status.classList.add("r2p--info");
        status.innerHTML = "✨ " + nm + " ist nicht in der Sofort-Vorschau – <strong>wir gestalten dein Design individuell von Hand.</strong> Die Vorschau zeigt nur das Farb-Bild; dein Name wird im selben Stil gesetzt.";
      }
    }

    // ====== combobox preset ======
    var activeIdx = -1;
    function setOpen(o) {                                   // đồng bộ trạng thái mở/đóng lên nút ▾ + combo
      var combo = list.parentNode;
      if (combo && combo.classList) combo.classList.toggle("r2p--open", !!o);
      if (caret) caret.setAttribute("aria-expanded", o ? "true" : "false");
    }
    function hideList() { list.hidden = true; activeIdx = -1; setOpen(false); }
    function pick(n) { input.value = n; hideList(); syncHidden(); }
    function renderList(q) {
      if (CANVAS) { if (list) list.hidden = true; return; }   // V2: không gợi ý
      q = (q || "").trim(); var ql = q.toLowerCase();
      var matches = names.filter(function (n) { return !ql || n.toLowerCase().indexOf(ql) === 0; });
      list.innerHTML = "";
      if (!matches.length) {
        var e = document.createElement("li"); e.className = "r2p__empty";
        e.textContent = q ? "Kein Treffer – nutze das Feld „Eigener Name“ unten" : "Tippe einen Namen…";
        list.appendChild(e); list.hidden = false; activeIdx = -1; setOpen(true); return;
      }
      matches.slice(0, 600).forEach(function (n) {
        var li = document.createElement("li"); li.dataset.name = n;
        if (ql) { var i = n.toLowerCase().indexOf(ql); li.innerHTML = esc(n.slice(0, i)) + "<mark>" + esc(n.slice(i, i + q.length)) + "</mark>" + esc(n.slice(i + q.length)); }
        else li.textContent = n;
        li.addEventListener("mousedown", function (ev) { ev.preventDefault(); pick(n); });
        list.appendChild(li);
      });
      list.hidden = false; activeIdx = -1; setOpen(true);
    }
    function highlight(items) { items.forEach(function (it, i) { it.classList.toggle("r2p--active", i === activeIdx); }); if (items[activeIdx]) items[activeIdx].scrollIntoView({ block: "nearest" }); }

    // ===== CHẶN ký tự không in được (V2 canvas): tầng 1 regex tức thì (emoji/ký hiệu), tầng 2 đối chiếu glyph font đang chọn =====
    var charWarnEl = null, charWarnT = null;
    function showCharWarn(chars) {
      if (!charWarnEl) {
        charWarnEl = document.createElement("div");
        charWarnEl.style.cssText = "margin-top:6px;font-size:12px;line-height:1.4;color:#b45309;background:#fef3c7;border:1px solid #fcd34d;border-radius:8px;padding:7px 10px;display:none";
        input.parentNode.insertBefore(charWarnEl, input.nextSibling);
      }
      var list = chars.map(function (c) { return "„" + c + "“"; }).join(", ");
      charWarnEl.textContent = "⚠️ " + list + (chars.length > 1 ? " können" : " kann") + " leider nicht gedruckt werden und wurde entfernt.";
      charWarnEl.style.display = "block";
      logName("blocked", { b: chars.join("") });
      clearTimeout(charWarnT); charWarnT = setTimeout(function () { charWarnEl.style.display = "none"; }, 5000);
    }
    var BAD_STATIC = IS_AGE ? /[^0-9]/g : /[^\p{L}\p{M}\p{N}\s\-.,']/gu;   // tầng 1: age = CHỈ chữ số; name = chữ (mọi bảng Latin) + số + cách + gạch + . , ' — emoji/ký hiệu chặn NGAY
    function sanitizeInput() {
      if (!CANVAS || !window.PodifyCanvas || !window.PodifyCanvas.badChars) return;
      var raw = input.value, bad1 = raw.match(BAD_STATIC) || [];
      if (bad1.length) {
        var pos0 = input.selectionStart || raw.length;
        input.value = raw.replace(BAD_STATIC, "");
        try { var d0 = raw.length - input.value.length; input.setSelectionRange(Math.max(0, pos0 - d0), Math.max(0, pos0 - d0)); } catch (e) {}
        showCharWarn(bad1.filter(function (c, i, a) { return a.indexOf(c) === i; }));
        syncHidden();
      }
      var val = input.value; if (!val) return;
      window.PodifyCanvas.badChars(val, curFont).then(function (bad) {   // tầng 2: glyph thật của font (số/accent tuỳ font)
        if (input.value !== val || !bad.length) return;
        var cleaned = val; bad.forEach(function (ch) { cleaned = cleaned.split(ch).join(""); });
        var pos = input.selectionStart || val.length;
        input.value = cleaned;
        try { var d = val.length - cleaned.length; input.setSelectionRange(Math.max(0, pos - d), Math.max(0, pos - d)); } catch (e) {}
        showCharWarn(bad);
        syncHidden(); schedBgPreview();
      });
    }
    input.addEventListener("input", function () { sanitizeInput(); renderList(input.value); syncHidden(); schedBgPreview(); });
    input.addEventListener("focus", function () { renderList(input.value); });
    input.addEventListener("blur", function () { setTimeout(hideList, 150); });
    input.addEventListener("keydown", function (e) {
      var items = list.querySelectorAll("li[data-name]");
      if (e.key === "ArrowDown") { e.preventDefault(); if (list.hidden) { renderList(input.value); return; } activeIdx = Math.min(activeIdx + 1, items.length - 1); highlight(items); }
      else if (e.key === "ArrowUp") { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); highlight(items); }
      else if (e.key === "Enter") { if (activeIdx > -1 && items[activeIdx]) { e.preventDefault(); pick(items[activeIdx].dataset.name); } else hideList(); }
      else if (e.key === "Escape") { hideList(); }
    });
    if (caret) caret.addEventListener("mousedown", function (ev) {   // mousedown+preventDefault: không cướp focus -> blur của input không đóng list tranh chấp
      ev.preventDefault();
      if (list.hidden) { renderList(input.value); input.focus(); } else { hideList(); }
    });

    // (ô tên riêng đã gộp vào ô chính — 1 trường duy nhất)

    // ====== màu (variant Minimog) ======
    function readColor() {
      var els = document.querySelectorAll("input[type=radio]:checked, select");
      for (var i = 0; i < els.length; i++) {
        var nm = (els[i].name || "").replace(/\s+/g, "").toLowerCase();
        if ((nm.indexOf("color") > -1 || nm.indexOf("farbe") > -1) && els[i].value) return slugify(els[i].value);
      }
      return currentColor;
    }
    document.addEventListener("change", function () {
      var c = readColor();
      if (c && c !== currentColor) { currentColor = c; updatePickerBg(); syncHidden(); if (!modal.hidden) paintModal(); updateStickyThumb(); schedBgPreview(); }
    }, true);

    // ====== modal ======
    function indivNote(v) { return "✨ „" + v + "“ wird individuell für dich gestaltet. Die finale Vorschau dient nur zur Orientierung."; }
    // Đặt overlay canvas theo vị trí V1 (t/l/w từ manifest/printArea) + height:auto (scale theo width, giống buildColoredMockup/tool Python).
    // 15/08: PA metafield SP (đã căn tab 🧵 / finalize resolve) là NGUỒN CHÂN LÝ cho MỌI phôi kể cả t-shirt — trước t-shirt dùng res.tlw
    // (suy từ place manifest) nên căn vùng in t-shirt không ăn lên PDP. Fallback tlw chỉ khi SP không có print_area (SP cũ).
    // ===== 1 NGUỒN VỊ TRÍ (user chốt 15/08: mọi SP cùng layout cùng phôi = cùng vị trí) =====
    // paFor(res): manifest layout pa[phôi] (nguồn SỐNG, đổi ở tab 🧵 là PDP đổi ngay) -> registry mặc định phôi (public CDN, cache)
    // -> metafield SP print_area (fallback SP cũ/legacy) -> tlw/const. Metafield không còn là nguồn chính.
    var GAR = cfg.garment || "t-shirt"; if (GAR === "tee") GAR = "t-shirt";
    var REG_PA = null, REG_PROMISE = null;
    function loadRegPA() {
      if (REG_PROMISE) return REG_PROMISE;
      // 22/08 PERF: bỏ cache-buster 5' (URL đổi liên tục = luôn đi mạng); registry trả s-maxage=300 -> edge/browser cache lo phần tươi.
      // 26/08 FIX: comment trên từng NUỐT mất .then(r.json()) (dính cùng dòng) -> j là Response, REG_PA=false vĩnh viễn, nhánh registry của paFor chết im lặng.
      REG_PROMISE = fetch(R2BASE + "/expand/garments.json", { cache: "default" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { var g = j && j.garments && j.garments[GAR]; REG_PA = (g && g.printArea && typeof g.printArea.width === "number") ? g.printArea : false; return REG_PA; })
        .catch(function () { REG_PA = false; return false; });
      return REG_PROMISE;
    }
    loadRegPA();
    function paFor(res) {
      var m = res && res.mfPa && res.mfPa[GAR];
      if (m && typeof m.width === "number") return { top: +m.top, left: +m.left, width: +m.width, height: (typeof m.height === "number") ? +m.height : (+m.width * 8 / 7), src: "layout" };
      if (REG_PA && typeof REG_PA.width === "number") return { top: +REG_PA.top, left: +REG_PA.left, width: +REG_PA.width, height: (typeof REG_PA.height === "number") ? +REG_PA.height : (+REG_PA.width * 8 / 7), src: "registry" };
      if (HAS_PA) return { top: pa.top, left: pa.left, width: pa.width, height: pa.height, src: "metafield" };
      return null;
    }
    function paBox(res) {
      var pf = paFor(res);
      var box = pf ? { top: pf.top, left: pf.left, width: pf.width }
        : ((IS_TEE && res && res.tlw) ? res.tlw : (IS_TEE ? { top: 22, left: 23.5, width: 53 } : { top: pa.top, left: pa.left, width: pa.width }));
      var paHeightSrc = pf ? pf.height : pa.height;
      // 15/08 GỐI/TÚI: canvas render là KHUNG 7:8 (design neo giữa khung, viền trong suốt) — đặt khung tại pa.top thì tâm khung ≠ tâm mặt in
      // (túi: khung tràn xuống đáy) -> căn TÂM KHUNG = TÂM DẢI MẶT IN [pa.top, pa.top+pa.height] theo chiều cao THẬT của canvas.
      if (FLAT_CENTER && res && res.w && res.h) {
        var paH = (typeof paHeightSrc === "number" && paHeightSrc > 0) ? paHeightSrc : box.width * 8 / 7;
        var boxH = box.width * (res.h / res.w);
        // căn theo TÂM MỰC THẬT (bbox alpha của canvas) chứ không phải tâm khung: khung 7:8 cắt mực trên/dưới không đối xứng
        // (bóng/viền dưới, dấu trên) -> tâm khung ≠ tâm design nhìn thấy -> lệch vài % dù đã center. inkMid = 0..1 trong canvas.
        var inkMid = inkCenterY(res.canvas);
        var offY = (inkMid != null) ? (0.5 - inkMid) * boxH : 0;   // dương = mực nằm cao trong khung -> đẩy khung XUỐNG bấy nhiêu
        box = { top: Math.round((box.top + paH / 2 - boxH / 2 + offY) * 10) / 10, left: box.left, width: box.width };
      }
      return box;
    }
    // Tâm mực theo chiều dọc (0..1) của canvas render — quét alpha trên bản thu nhỏ 64px (rẻ), cache theo canvas.
    function inkCenterY(cv) {
      if (!cv || !cv.width) return null;
      if (cv._inkMid != null) return cv._inkMid;
      try {
        var S = 64, t = document.createElement("canvas"); t.width = S; t.height = S;
        var tx = t.getContext("2d"); tx.drawImage(cv, 0, 0, S, S);
        var d = tx.getImageData(0, 0, S, S).data, top = -1, bot = -1;
        for (var y = 0; y < S; y++) { var hit = false; for (var x = 0; x < S; x++) { if (d[(y * S + x) * 4 + 3] > 24) { hit = true; break; } } if (hit) { if (top < 0) top = y; bot = y; } }
        if (top < 0) return null;
        cv._inkMid = (top + bot + 1) / 2 / S;
        return cv._inkMid;
      } catch (e) { return null; }
    }
    function applyCanvasPlace(res) {
      var t = paBox(res);
      overEl.style.top = t.top + "%"; overEl.style.left = t.left + "%"; overEl.style.width = t.width + "%"; overEl.style.height = "auto";
    }
    function setOverlay(url) { try { if (overEl._ou) URL.revokeObjectURL(overEl._ou); } catch (e) {} overEl.src = url; overEl._ou = (url && url.indexOf("blob:") === 0) ? url : ""; }
    // Serialize canvas render: CHỈ 1 render chạy 1 lúc, bấm nhanh -> gộp về lần MỚI NHẤT (chống đơ khi thao tác dồn dập).
    // FIX xoay-vô-hạn: (1) after ĐƯỢC GỌI CẢ KHI LỖI (res=null) -> spinner tự tắt/retry; (2) cùng combo -> GỘP after
    // (không ghi đè vứt mất showSpin(false) của modal); (3) watchdog 30s -> render treo không kẹt hàng đợi vĩnh viễn;
    // (4) kết quả stale (tên đã đổi trong lúc render) -> tự render lại giá trị HIỆN TẠI với cùng after thay vì bỏ rơi.
    var _rBusy = false, _rPend = null;
    function doCanvasRender(v, rf, rl, after) {
      if (_rBusy) {
        if (_rPend && _rPend[0] === v && _rPend[1] === rf && _rPend[2] === rl) {
          var a1 = _rPend[3], a2 = after;
          _rPend[3] = function (res) { if (a1) a1(res); if (a2) a2(res); };
        } else _rPend = [v, rf, rl, after];
        return;
      }
      _rBusy = true; var kx0 = keyX();   // 01/11 📷 photo3: ảnh / vị trí khách đổi giữa chừng -> kết quả coi là stale (nhánh vẽ lại có sẵn)
      var settled = false, wd = setTimeout(function () { settle(null); }, 30000);
      function settle(res) {
        if (settled) return; settled = true; clearTimeout(wd); _rBusy = false;
        if (res && res.url && effectiveName() === v && curFont === rf && curLayout === rl && keyX() === kx0) { try { after(res); } catch (e) {} }   // 01/11 📷 photo3: + keyX
        else if (res && res.url) {   // stale: tên/font/layout đổi giữa chừng -> bỏ blob, render lại giá trị hiện tại (spinner tắt ở lần đó)
          if (res.url.indexOf("blob:") === 0) { try { URL.revokeObjectURL(res.url); } catch (e) {} }
          if (!_rPend) { var vn = effectiveName(); if (OPT && vn !== v) _rPend = [vn, curFont, curLayout, optReAfter(vn)]; else if (vn || OPT) _rPend = [vn, curFont, curLayout, after]; else { try { after(null); } catch (e) {} } }   // 15/10: OPT -> tên vừa xoá trống vẫn render lại (bản không tên); TÊN đổi -> after mới (optReAfter), không dùng closure tên cũ
        }
        else { try { after(null); } catch (e) {} }   // lỗi/timeout -> báo caller, KHÔNG nuốt im lặng
        if (_rPend) { var p = _rPend; _rPend = null; doCanvasRender(p[0], p[1], p[2], p[3]); }
      }
      window.PodifyCanvas.render(v, { fontId: rf, layoutId: rl, anchor: FLAT_CENTER ? "center" : null }).then(settle).catch(function () { settle(null); });
    }
    // ===== _preview cho TÊN CUSTOM (canvas): ghép phôi+design -> upload public -> URL vào cart/mail (mail template đã đọc _preview như V1) =====
    var PREVIEW_EP = "https://blazora-portal.minhduc711qn.workers.dev/public/cart-preview";
    // NAME-LOG: ghi mọi tương tác ô tên (tối ưu sau) — sendBeacon text/plain = simple request, không chặn UI
    var NAMELOG_EP = PREVIEW_EP.replace("/cart-preview", "/name-log");
    var _nlLast = "";
    function logName(ev, extra) {
      if (!CANVAS) return;
      try {
        var v = effectiveName();
        if (!v && ev !== "blocked" && !(OPT && ev === "atc")) return;   // 15/10: SP tên không bắt buộc -> ATC không tên vẫn ghi (đếm ATC theo design)
        if (ev === "settle") { if (v === _nlLast) return; _nlLast = v; }
        var payload = { e: ev, n: v, f: curFont, l: curLayout, c: currentColor, p: (location.pathname.split("/products/")[1] || "").split("?")[0] };
        if (extra) for (var kk in extra) payload[kk] = extra[kk];
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) navigator.sendBeacon(NAMELOG_EP, new Blob([body], { type: "text/plain" }));
        else fetch(NAMELOG_EP, { method: "POST", body: body, keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    var canvasPrevUrl = "", canvasPrevKey = "";
    var canvasUpPending = "";   // 26/08: combo đang upload dở — chống POST /public/cart-preview ĐÚP (bg preview + modal cùng render 1 combo)
    var canvasStickyUrl = "", canvasStickyKey = "";   // bản LOCAL (objectURL) cho sticky bar — hiện NGAY, không chờ upload
    function keyX() { try { var x = window.__r2pKeyX ? String(window.__r2pKeyX() || "") : ""; return x ? "|" + x : ""; } catch (e) { return ""; } }   // 01/11 📷 photo3 (V3 r3-photo): khoá phụ cho cache ảnh ghép — trang V2 không có hook -> "" (khoá y hệt cũ)
    function cartPrevKey(v) { return v + "|" + curFont + "|" + curLayout + "|" + currentColor + keyX(); }
    function uploadCartPreview(res, v) {
      var k = cartPrevKey(v);
      if (res && res.warnings && res.warnings.some(function (w) { return w && w.code === "photo_mask_failed"; })) return;   // 02/11 📷 photo4 r1: mask not loaded -> slot skipped in this render, no _preview for it (cart keeps the default image; the next good render uploads)
      if (canvasPrevKey === k && canvasPrevUrl) { syncHidden(); updateStickyThumb(); return; }   // combo này đã up rồi
      if (canvasUpPending === k) return;   // đang up combo này rồi -> khỏi bắn thêm
      canvasUpPending = k;
      var mock = new Image(); mock.crossOrigin = "anonymous";
      mock.onerror = function () { if (canvasUpPending === k) canvasUpPending = ""; /* mock CORS/404 -> bỏ qua, cart dùng ảnh mặc định */ };
      mock.onload = function () {
        try {
          var W = 800, c = document.createElement("canvas"); c.width = W; c.height = W;
          var cx = c.getContext("2d"); cx.imageSmoothingQuality = "high"; cx.drawImage(mock, 0, 0, W, W);
          var t = paBox(res);
          var dsrc = res.canvas || null; if (!dsrc) return;   // vẽ THẲNG design-canvas -> khỏi decode PNG ~3.4MB (nguồn gây đơ)
          (function () {
            var dw = t.width / 100 * W, dh = dw * (res.h / res.w);
            cx.drawImage(dsrc, t.left / 100 * W, t.top / 100 * W, dw, dh);
            // iOS/Safari KHÔNG encode được webp trong toBlob (trả PNG to đùng > cap) -> fallback JPEG (composite có nền phôi, không cần trong suốt)
            var encode = function (done) {
              c.toBlob(function (b) {
                if (b && b.type === "image/webp" && b.size <= 390 * 1024) return done(b);
                c.toBlob(function (b2) { done((b2 && b2.size <= 390 * 1024) ? b2 : (b && b.size <= 390 * 1024 ? b : null)); }, "image/jpeg", 0.8);
              }, "image/webp", 0.85);
            };
            encode(function (b) {
              if (!b) { if (canvasUpPending === k) canvasUpPending = ""; return; }
              // sticky bar hiện ảnh cá nhân hoá NGAY (local, không chờ mạng) -> đẩy khách bấm add-to-cart
              try { if (canvasStickyUrl && canvasStickyUrl.indexOf("blob:") === 0) URL.revokeObjectURL(canvasStickyUrl); } catch (e2) {}
              canvasStickyUrl = URL.createObjectURL(b); canvasStickyKey = k; updateStickyThumb();
              fetch(PREVIEW_EP, { method: "POST", headers: { "content-type": b.type || "image/webp" }, body: b })
                .then(function (r) { return r.json(); })
                .then(function (j) {
                  if (canvasUpPending === k) canvasUpPending = "";
                  if (!(j && j.ok && effectiveName() === v && cartPrevKey(v) === k)) return;
                  // _preview = URL R2 (cart theme + mail hiện ảnh ngay qua R2 public). Function cart-transform TỰ MAP R2->Shopify
                  // cho ảnh CHECKOUT (basename 1-1) -> tới lúc checkout file đã sẵn -> ảnh hiện. KHÔNG swap sang Shopify URL ở client
                  // (không cần: function lo mapping). Giữ _preview=R2 ổn định -> cart line LUÔN có _preview -> checkout luôn có ảnh.
                  canvasPrevKey = k; canvasPrevUrl = j.url; syncHidden();
                })
                .catch(function () { if (canvasUpPending === k) canvasUpPending = ""; });
            });
          })();
        } catch (e) { if (canvasUpPending === k) canvasUpPending = ""; /* taint/CORS -> bỏ qua, cart dùng ảnh SP mặc định */ }
      };
      // ?cors=1: mockup đã bị modal load KHÔNG crossOrigin -> cache không có ACAO -> load lại VỚI crossOrigin
      // dính cache cũ và FAIL (cache-poisoning). Query khác = cache-key khác = fetch CORS sạch.
      var mu = mockUrl(currentColor);
      mock.src = mu + (mu.indexOf("?") >= 0 ? "&" : "?") + "cors=1";
    }
    // Ghép design (tên hiện tại của khách) lên phôi MÀU bất kỳ -> dataURL. Cho LỚP PHỦ GALLERY khi khách đổi màu
    // sau khi đã nhập tên (thay vì hiện phôi trơn). Chưa nhập tên -> cb(null) để dùng ảnh placeholder cũ.
    var _colorPrevCache = {}, _colorPrevKeys = [];   // color|name|font|layout -> dataURL; CAP 12 entry (26/08 — mỗi entry ~100KB JPEG, không cap = phình RAM khi khách nghịch nhiều tên/màu)
    function composeOnColor(color, cb) {
      var v = effectiveName();
      if (!CANVAS || (!v && !OPT)) return cb(null);   // 15/10: tên không bắt buộc + trống -> ghép design KHÔNG tên (không phủ áo trơn lên gallery)
      var ck = color + "|" + v + "|" + curFont + "|" + curLayout + keyX();   // 01/11 📷 photo3: + keyX (V2: "")
      if (_colorPrevCache[ck]) return cb(_colorPrevCache[ck], ck);   // 01/11 ⌨️ live: + khoá ảnh ghép (lớp phủ gõ-trực-tiếp V3 biết ảnh nào khớp; V2 không đọc tham số 2)
      doCanvasRender(v, curFont, curLayout, function (res) {
        if (!res || !res.canvas) return cb(null);
        var kr = LIVE ? (color + "|" + effectiveName() + "|" + curFont + "|" + curLayout + keyX()) : ck;   // 01/11 ⌨️ live (CHỈ V3): khoá THẬT của ảnh vừa vẽ (lúc settle) — kết quả stale vẽ lại tên MỚI không bị cất nhầm dưới khoá tên cũ; V2: = ck như cũ
        var mock = new Image(); mock.crossOrigin = "anonymous";
        mock.onerror = function () { cb(null); if (res.url && res.url.indexOf("blob:") === 0) { var _ce = res.url; setTimeout(function () { if (_ce !== overEl._ou) { try { URL.revokeObjectURL(_ce); } catch (e) {} } }, 0); } };   // 26/08: mock lỗi cũng dọn blob (trước đây leak), có guard overlay
        mock.onload = function () {
          try {
            var W = 800, c = document.createElement("canvas"); c.width = W; c.height = W;
            var cx = c.getContext("2d"); cx.imageSmoothingQuality = "high"; cx.drawImage(mock, 0, 0, W, W);
            var t = paBox(res);
            var dw = t.width / 100 * W, dh = dw * (res.h / res.w);
            cx.drawImage(res.canvas, t.left / 100 * W, t.top / 100 * W, dw, dh);
            var u = c.toDataURL("image/jpeg", 0.9);   // JPEG (composite có nền áo, không cần trong suốt) -> nhẹ ~100KB thay 2.3MB PNG (mobile)
            _colorPrevCache[kr] = u; _colorPrevKeys.push(kr);   // 01/11 ⌨️ live: kr (V2: kr = ck)
            if (_colorPrevKeys.length > 12) { delete _colorPrevCache[_colorPrevKeys.shift()]; }
            if (OPT) { try { updateStickyThumb(); } catch (e3) {} }   // audit T-03: ảnh ghép màu này sẵn -> thumb sticky dùng luôn
            cb(u, kr);   // 01/11 ⌨️ live: + khoá (V2 không đọc)
          } catch (e) { cb(null); }
          // 26/08: HOÃN revoke + bỏ qua nếu blob đang là overlay modal — doCanvasRender GỘP callback khi combo trùng
          // nên res.url dùng CHUNG với modalAfter; revoke thẳng từng giết blob overlay đang decode (cùng pattern schedBgPreview).
          if (res.url && res.url.indexOf("blob:") === 0) { var _cu = res.url; setTimeout(function () { if (_cu !== overEl._ou) { try { URL.revokeObjectURL(_cu); } catch (e) {} } }, 0); }
        };
        var mu = mockUrl(color); mock.src = mu + (mu.indexOf("?") >= 0 ? "&" : "?") + "cors=1";
      });
    }
    window.__r2pColorPreview = composeOnColor;   // cầu nối sang scope lớp phủ gallery (setupGallery)
    if (window.PodifyCanvas && window.PodifyCanvas.v3) { window.__r2pKeyChanged = function () { syncHidden(); schedBgPreview(); }; window.__r2pState = function () { return { color: currentColor, font: curFont, layout: curLayout, name: effectiveName(), paBox: paBox }; }; }   // 01/11 📷 photo3: r3-photo gọi khi ảnh / vị trí đổi + đọc màu/font/layout/khung in (CHUNG hàm paBox với lớp phủ) — CHỈ trang V3 (shim defer chạy trước r2p đã gắn PodifyCanvas.v3); trang V2 không có 2 global này
    // 01/11 ⌨️ live-typing (chủ shop yêu cầu, kiểu werkerz / Teeinblue) — CHỈ trang V3 (shim có PodifyCanvas.v3.live; trang V2: LIVE = false -> khối này không gắn gì).
    //   Khách bấm vào / gõ ô tên -> lớp phủ gallery hiện NGAY design trên màu đang chọn và vẽ lại theo TỪNG PHÍM: gộp theo requestAnimationFrame, tối đa
    //   1 lượt vẽ đang chạy + 1 lượt chờ (= trạng thái MỚI NHẤT), kết quả cũ bị bỏ. Lúc gõ: vẽ NHẸ (maxW LIVE_W, không blob / JPEG) rồi ghép 800 px y như
    //   composeOnColor lên 1 canvas phủ TRÊN ảnh lớp phủ. Ngừng gõ: đường cũ (schedBgPreview 400 ms -> __r2pGalleryRefresh -> composeOnColor, render 1400)
    //   đặt ảnh ĐỦ cỡ; ảnh đó khớp đúng trạng thái + giải mã xong -> ẩn canvas. Upload _preview + name-log GIỮ debounce 400 ms cũ (không upload theo phím).
    //   Không tự bật khi khách đang vuốt gallery / vừa tự đóng lớp phủ (tới lần bấm ô tên sau). Lớp phủ ngoài màn hình (điện thoại: gallery ở trên, bàn phím
    //   đang mở) -> không vẽ từng phím; cuộn tới gallery thì vẽ + bật. Đo: window.__r2pLive.stats = [{q: ms chờ khung (rAF), r: ms render, p: ms ghép, w: maxW, n: số ký tự, stale, err}].
    var LIVE = CANVAS && !!(window.PodifyCanvas && window.PodifyCanvas.v3 && typeof window.PodifyCanvas.v3.live === "function");
    var LIVE_W = 480, LIVE_C = 800;   // maxW lúc gõ (design ~344 px trong ảnh ghép 800 -> 480 đủ nét) · cạnh ảnh ghép = composeOnColor
    var _lv = { busy: 0, want: 0, raf: 0, open: 0, eng: 0, d: null, bufs: [], bi: 0, shown: "", imgK: "", mk: {}, mkK: [], fIdle: 0, idleT: 0, pend: 0, rq: 0, q: 0 };
    function lvNow() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    function lvDk() { return effectiveName() + "|" + curFont + "|" + curLayout + keyX(); }
    function lvG() { var g = window.__r2pGalleryLive; return (LIVE && g && g.ok) ? g : null; }
    function lvStat(o) { try { var s = window.__r2pLive || (window.__r2pLive = { stats: [] }); o.t = Date.now(); s.stats.push(o); if (s.stats.length > 200) s.stats.shift(); } catch (e) {} }
    function lvReq(open) {
      if (!LIVE) return;
      if (open) _lv.open = 1;
      if (!_lv.want) _lv.rq = lvNow();   // lúc phím đầu tiên của lượt này xin khung (đo q)
      _lv.want = 1;
      if (_lv.raf || _lv.busy) return;   // đã hẹn khung / đang vẽ -> lượt sau tự lấy trạng thái MỚI NHẤT
      _lv.raf = requestAnimationFrame(lvRun);
    }
    function lvMock(color) {   // phôi màu cho ảnh ghép — CÙNG URL ?cors=1 với composeOnColor / uploadCartPreview (chung cache trình duyệt); giữ tối đa 3 màu (RAM iOS)
      var m = _lv.mk[color];
      if (m) return m;
      m = _lv.mk[color] = { ok: 0, err: 0, cbs: [], img: new Image() };
      _lv.mkK.push(color);
      if (_lv.mkK.length > 3) { var oc = _lv.mkK.shift(), om = _lv.mk[oc]; delete _lv.mk[oc]; if (om) { om.cbs = []; om.img.onload = om.img.onerror = null; om.img.removeAttribute("src"); } }
      m.img.crossOrigin = "anonymous";
      m.img.onload = function () { m.ok = 1; var c = m.cbs; m.cbs = []; c.forEach(function (f) { try { f(); } catch (e) {} }); };
      m.img.onerror = function () { m.err = 1; m.cbs = []; if (_lv.mk[color] === m) { delete _lv.mk[color]; _lv.mkK = _lv.mkK.filter(function (c) { return c !== color; }); } };   // phôi lỗi -> lần sau thử lại; lớp phủ dùng đường cũ
      var mu = mockUrl(color); m.img.src = mu + (mu.indexOf("?") >= 0 ? "&" : "?") + "cors=1";
      return m;
    }
    function lvRun() {
      _lv.raf = 0;
      var G = lvG(); if (!G || !_lv.want || _lv.busy) return;
      _lv.q = Math.round(lvNow() - _lv.rq); _lv.want = 0;
      var auto = !G.on();
      if (auto && !(_lv.open && G.canAuto())) { _lv.open = 0; return; }   // lớp phủ đang tắt: chỉ tự bật khi khách bấm / gõ ô tên, không đang vuốt gallery, chưa tự đóng
      if (!G.vis() && !mnWant()) { _lv.pend = 1; return; }   // ngoài màn hình: KHÔNG vẽ từng phím — cuộn tới gallery (IntersectionObserver -> r2p:galvis) thì vẽ + bật; TRỪ khi thẻ mini cần khung (điện thoại, ô tên đang focus)
      _lv.pend = 0;
      var dk = lvDk(), k = currentColor + "|" + dk;
      if (_lv.imgK === k) { G.live(false); _lv.shown = ""; if (auto) G.open(); _lv.open = 0; mnSync(1); return; }   // ảnh ĐỦ cỡ đúng trạng thái này đã nằm trong lớp phủ
      if (_lv.shown === k && G.isLive()) { if (auto) G.open(); _lv.open = 0; mnSync(1); return; }
      if (_lv.d && _lv.d.dk === dk) { lvPaint(_lv.d, currentColor, null); return; }   // design không đổi (đổi màu / mở lại) -> chỉ ghép lại, khỏi render
      _lv.busy = 1;
      var cv = _lv.bufs[_lv.bi] || (_lv.bufs[_lv.bi] = document.createElement("canvas")), t0 = lvNow();
      window.PodifyCanvas.v3.live(effectiveName(), { fontId: curFont, layoutId: curLayout, maxW: LIVE_W, canvas: cv })
        .then(function (d) { lvDone(d, dk, t0); }, function () { lvDone(null, dk, t0); });
    }
    function lvDone(d, dk, t0) {
      _lv.busy = 0;
      var ms = Math.round(lvNow() - t0);
      if (d && d.canvas && dk === lvDk()) { d.dk = dk; _lv.d = d; _lv.bi = 1 - _lv.bi; lvPaint(d, currentColor, ms); }   // giữ bản này, lượt sau vẽ vào buffer kia
      else { lvStat({ q: _lv.q, r: ms, w: LIVE_W, stale: d ? 1 : 0, err: d ? 0 : 1 }); if (d) _lv.want = 1; }   // CŨ (khách gõ tiếp giữa chừng) -> bỏ, vẽ trạng thái mới nhất
      if (_lv.want && !_lv.raf) _lv.raf = requestAnimationFrame(lvRun);
    }
    function lvPaint(d, color, rms) {
      var G = lvG(); if (!G) return;
      if (!G.on() && !(_lv.open && G.canAuto())) { _lv.open = 0; return; }   // khách vừa tự đóng / đang vuốt -> không bật lại
      var m = lvMock(color);
      if (!m.ok) { if (!m.err) m.cbs.push(function () { if (_lv.d === d && color === currentColor) lvPaint(d, color, rms); }); return; }
      var t0 = lvNow(), c = G.canvas, W = LIVE_C;
      try {
        if (c.width !== W) { c.width = W; c.height = W; }
        var cx = c.getContext("2d"); cx.imageSmoothingQuality = "high"; cx.drawImage(m.img, 0, 0, W, W);
        var t = paBox(d), dw = t.width / 100 * W, dh = dw * (d.h / d.w);
        cx.drawImage(d.canvas, t.left / 100 * W, t.top / 100 * W, dw, dh);
      } catch (e) { return; }
      _lv.shown = color + "|" + d.dk;
      G.live(true); if (!G.on()) G.open(); _lv.open = 0;
      mnSync(1);   // thẻ mini chép ĐÚNG khung vừa vẽ (cùng task -> cùng frame)
      lvStat({ q: _lv.q, r: rms == null ? -1 : rms, p: Math.round(lvNow() - t0), w: LIVE_W, n: effectiveName().length });
      if (_lv.fIdle) {   // mới bấm vào ô / vừa cuộn tới (chưa gõ): 400 ms sau xin ảnh ĐỦ cỡ như đường cũ (đang gõ thì schedBgPreview đã lo)
        _lv.fIdle = 0; clearTimeout(_lv.idleT);
        _lv.idleT = setTimeout(function () { var g = lvG(); if (g && g.on() && g.isLive() && window.__r2pGalleryRefresh) window.__r2pGalleryRefresh(currentColor); }, 400);
      }
    }
    function lvEngage() { var G = lvG(); if (!G) return; G.refocus(); _lv.eng = 1; _lv.fIdle = 1; lvReq(true); }
    // 01/11 ⌨️ live — THẺ XEM TRƯỚC MINI (điện thoại): gallery nằm ~900 px trên ô tên -> lúc bàn phím mở khách không thấy chữ hiện ra (đa số khách từ Meta ads).
    //   Hiện khi: LIVE (V3) + màn hẹp (max-width 767px) + ô tên đang focus + lớp phủ gallery thấy < 40 % trong window.visualViewport + lớp phủ đang có khung.
    //   Cố định góc TRÊN-PHẢI của VÙNG NHÌN THẬT (visualViewport offsetTop/height -> luôn nằm trên bàn phím iOS / Android); đè ô tên -> góc DƯỚI-PHẢI ngay trên
    //   bàn phím; vẫn đè (màn quá thấp) -> ẩn. Nội dung = drawImage ĐÚNG khung lớp phủ đang có (canvas bản sống / ảnh ghép đủ cỡ — đã gồm ảnh khách nếu có),
    //   KHÔNG render engine thêm (ô tên focus thì bản sống vẽ cả khi gallery ngoài màn hình vì thẻ cần khung). KHÔNG đụng FormData / properties / _preview /
    //   upload; không global mới. Tạo lười (chưa có DOM tới lần focus đầu trên màn hẹp); blur -> gỡ khỏi DOM sau 300 ms; × = tắt tới hết lượt xem trang (bàn phím
    //   giữ nguyên); chạm thẻ -> đóng bàn phím + cuộn mượt tới gallery (prefers-reduced-motion -> nhảy thẳng). z-index 990: trên sticky ATC (40) / header (82) /
    //   cổng mua (500), dưới hộp xem trước r2p (99999) + tấm đặt ảnh r3-photo (100000). Chữ: «Live-Vorschau» = xem trước trực tiếp · «Vorschau schließen» = đóng.
    var _mn = { el: null, cv: null, f: 0, off: 0, on: 0, t: 0, raf: 0, k: "", w: 0, mq: null, bound: 0 };
    function mnNarrow() { try { return (_mn.mq || (_mn.mq = window.matchMedia("(max-width: 767px)"))).matches; } catch (e) { return false; } }
    function mnWant() { return LIVE && _mn.f && !_mn.off && mnNarrow(); }
    function mnHide() { if (_mn.el && _mn.on) { _mn.el.style.display = "none"; _mn.on = 0; } }
    function mnReq() { if ((_mn.f || _mn.on) && !_mn.raf) _mn.raf = requestAnimationFrame(function () { _mn.raf = 0; mnSync(0); }); }
    function mnBuild() {
      var el = _mn.el = document.createElement("div"), cv = _mn.cv = document.createElement("canvas"), lb = document.createElement("div"), xb = document.createElement("button");
      el.className = "r2p-mini";
      el.style.cssText = "position:fixed;left:0;top:0;z-index:990;display:none;box-sizing:border-box;margin:0;padding:0;border:1px solid rgba(0,0,0,.1);border-radius:12px;background:#fff;box-shadow:0 6px 20px rgba(0,0,0,.18);overflow:hidden;cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation";
      cv.setAttribute("role", "img"); cv.setAttribute("aria-label", "Live-Vorschau"); cv.style.cssText = "display:block;margin:0";
      lb.style.cssText = "height:18px;padding:0 6px;font:700 11px/18px -apple-system,system-ui,sans-serif;color:#1f2328;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis";
      lb.innerHTML = '<span aria-hidden="true" style="display:inline-block;width:6px;height:6px;margin:0 4px 1px 0;border-radius:50%;background:#e5484d;vertical-align:middle"></span>Live-Vorschau';
      xb.type = "button"; xb.setAttribute("aria-label", "Vorschau schließen");
      xb.style.cssText = "position:absolute;top:0;right:0;box-sizing:border-box;width:32px;height:32px;margin:0;padding:4px 4px 0 0;border:0;background:transparent;cursor:pointer;display:flex;align-items:flex-start;justify-content:flex-end";
      xb.innerHTML = '<span aria-hidden="true" style="display:block;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;font:700 15px/22px sans-serif;text-align:center">×</span>';
      el.appendChild(cv); el.appendChild(lb); el.appendChild(xb);
      el.addEventListener("mousedown", function (e) { e.preventDefault(); });   // chạm thẻ / × KHÔNG lấy focus khỏi ô tên (thẻ không bị gỡ giữa cú chạm)
      xb.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); _mn.off = 1; mnHide(); });   // × -> tắt tới hết lượt xem trang
      el.addEventListener("click", function (e) {   // chạm thẻ -> đóng bàn phím + cuộn tới gallery (lớp phủ cỡ lớn)
        e.preventDefault(); var G = lvG(); mnHide(); try { input.blur(); } catch (x) {}
        if (!G || !G.el) return;
        var rm = false; try { rm = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (x) {}
        try { G.el.scrollIntoView({ block: "center", behavior: rm ? "instant" : "smooth" }); } catch (x) { try { G.el.scrollIntoView(true); } catch (y) {} }
      });
    }
    function mnDraw(src, cw) {
      var cv = _mn.cv, px = Math.max(1, Math.round(cw * Math.min(2, window.devicePixelRatio || 1)));
      if (cv.width !== px) { cv.width = px; cv.height = px; }
      var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height; if (!sw || !sh) return;
      try {
        var cx = cv.getContext("2d"), s = Math.min(px / sw, px / sh), dw = sw * s, dh = sh * s;
        cx.fillStyle = "#fff"; cx.fillRect(0, 0, px, px); cx.imageSmoothingQuality = "high";
        cx.drawImage(src, (px - dw) / 2, (px - dh) / 2, dw, dh);
      } catch (e) {}
    }
    function mnSync(draw) {
      var G = lvG();
      if (!mnWant() || !G || !G.el || !G.on()) return mnHide();
      var src = G.isLive() ? G.canvas : (G.imgOk() ? G.img : null);
      if (!src) return mnHide();
      var vv = window.visualViewport, vt = vv ? vv.offsetTop : 0, vl = vv ? vv.offsetLeft : 0, vw = vv ? vv.width : window.innerWidth, vh = vv ? vv.height : window.innerHeight;
      var r = G.el.getBoundingClientRect(), a = r.width * r.height;
      var seen = a > 0 ? Math.max(0, Math.min(r.right, vl + vw) - Math.max(r.left, vl)) * Math.max(0, Math.min(r.bottom, vt + vh) - Math.max(r.top, vt)) / a : 0;
      if (seen >= 0.4) return mnHide();   // gallery thấy đủ rõ -> không cần thẻ
      if (!_mn.el) mnBuild();
      var el = _mn.el, M = 8, w = Math.round(Math.min(150, vw * 0.34)), cw = w - 2;   // ≈ 34vw, tối đa 150 px (viền 1 px mỗi bên)
      if (_mn.w !== w) { _mn.w = w; el.style.width = w + "px"; _mn.cv.style.width = _mn.cv.style.height = cw + "px"; draw = 1; }
      var h = w + 18, x = vl + vw - w - M, y = vt + M, ir = input.getBoundingClientRect();   // cao = viền + ảnh vuông + dòng chữ 18 px
      function hit(yy) { return ir.right > x - 4 && ir.left < x + w + 4 && ir.bottom > yy - 4 && ir.top < yy + h + 4; }
      if (hit(y)) { y = vt + vh - h - M; if (hit(y) || y < vt + M) return mnHide(); }   // đè ô tên -> góc dưới-phải ngay trên bàn phím; vẫn đè -> ẩn
      if (!el.parentNode) document.body.appendChild(el);
      el.style.transform = "translate(" + Math.round(x) + "px," + Math.round(y) + "px)";
      var k = src === G.canvas ? "L" + _lv.shown : "I" + G.imgSrc();
      if (draw || !_mn.on || _mn.k !== k) { mnDraw(src, cw); _mn.k = k; }
      if (!_mn.on) { el.style.display = "block"; _mn.on = 1; }
    }
    function mnFocus() {
      if (_mn.off || !mnNarrow()) return;
      _mn.f = 1; clearTimeout(_mn.t);
      var G = lvG(); if (G) G.chg = mnReq;   // lớp phủ bật / tắt (✕, vuốt) -> thẻ theo
      if (!_mn.bound) {   // gắn lười (lần focus đầu trên màn hẹp); lúc rảnh mnReq bỏ qua ngay
        _mn.bound = 1;
        var vv = window.visualViewport;
        if (vv) { vv.addEventListener("resize", mnReq); vv.addEventListener("scroll", mnReq); }
        window.addEventListener("scroll", mnReq, { passive: true }); window.addEventListener("resize", mnReq);
      }
      mnReq();
    }
    function mnBlur() {
      _mn.f = 0; clearTimeout(_mn.t);
      _mn.t = setTimeout(function () { if (_mn.f) return; mnHide(); if (_mn.el && _mn.el.parentNode) _mn.el.parentNode.removeChild(_mn.el); }, 300);
    }
    if (LIVE) {
      window.__r2pColorPreview = function (color, cb) {   // bọc cầu nối lớp phủ: ghi nhận ảnh ĐỦ cỡ nào đang nằm trong lớp phủ (khoá) để bản sống nhường chỗ
        var G = lvG();
        if (G && G.on() && _lv.eng) lvReq(false);   // lớp phủ đang bật + khách đã dùng ô tên: ghép ngay màu / design mới bằng bản sống, khỏi chờ render 1400
        composeOnColor(color, function (u, k) {
          cb(u, k);
          var g = lvG(); if (!g) return;
          if (!u) { _lv.imgK = ""; return; }   // show() rơi về ảnh phôi mẫu (colorImages)
          if (g.imgSrc() !== u) return;   // show() bỏ kết quả này (khách đã sang màu khác)
          _lv.imgK = "";
          g.decoded(function () {
            if (g.imgSrc() !== u) return;
            _lv.imgK = k || "";
            if (k && k === currentColor + "|" + lvDk() && g.isLive()) { g.live(false); _lv.shown = ""; }   // ảnh đủ cỡ ĐÚNG trạng thái hiện tại đã giải mã -> thay bản sống
            mnSync(1);   // thẻ mini chép cái lớp phủ đang hiện
          });
        });
      };
      input.addEventListener("focus", function (e) { if (e.isTrusted) { mnFocus(); lvEngage(); } });
      input.addEventListener("blur", mnBlur);
      input.addEventListener("click", function (e) { if (e.isTrusted) lvEngage(); });
      input.addEventListener("input", function (e) {
        _lv.fIdle = 0; clearTimeout(_lv.idleT);
        if (e.isTrusted) _lv.eng = 1; else if (!_lv.eng) return;   // điền tự động (state-carry / ?pname) KHÔNG tự bật lớp phủ
        var G = lvG(); if (G) lvReq(e.isTrusted && !G.on());
      });
      root.addEventListener("click", function (e) {   // đổi font / design (chip) -> vẽ lại bản sống ngay
        if (!_lv.eng || !(e.target && e.target.closest && e.target.closest(".r2p__opt"))) return;
        setTimeout(function () { var G = lvG(); if (G && G.on()) lvReq(false); }, 0);
      });
      window.addEventListener("r2p:galvis", function () { var G = lvG(); if (G && _lv.eng && (_lv.pend || G.on())) { _lv.fIdle = 1; lvReq(false); } });
      window.__r2pLivePhoto = function (open) { var G = lvG(); if (!G) return; if (open) G.refocus(); _lv.eng = 1; _lv.fIdle = 1; lvReq(!!open); };   // 02/11 📷 photo4 R1: r3-photo gọi sau khi ảnh / vị trí ảnh khách đổi (tải xong, đóng khung chỉnh) -> lớp phủ gallery vẽ lại «bản sống» CÓ ẢNH KHÁCH ngay (cả khi chưa nhập tên — schedBgPreview bỏ qua tên trống); open = true -> bật lớp phủ (khách vừa tải ảnh). Trang V2: không có hàm này.
    }
    // Ép render+upload NGAY (bỏ debounce) — dùng khi khách bấm add mà ảnh chưa sẵn.
    function ensurePreviewNow(v) {
      clearTimeout(_bgT);
      if (canvasPrevKey === cartPrevKey(v) && canvasPrevUrl) return;
      doCanvasRender(v, curFont, curLayout, function (res) { if (!res) return; uploadCartPreview(res, v); if (res.url && res.url.indexOf("blob:") === 0) { var _eu = res.url; setTimeout(function () { if (_eu !== overEl._ou) { try { URL.revokeObjectURL(_eu); } catch (e) {} } }, 0); } });   // 26/08: hoãn revoke + guard overlay (merge callback với modalAfter)
    }
    // Chặn submit tạm -> chờ _preview sẵn (poll 150ms, TRẦN 4.5s) -> tự submit lại. Timeout vẫn cho mua (không ảnh còn hơn mất đơn).
    // 15/10 audit T-02 (CHỈ OPT): lúc chờ ảnh không tên (vẽ + tải lên, ~1–4,5 s) nút mua hiện spinner chuẩn của theme (class m-spinner-loading
    // trên <product-form>: ẩn chữ, hiện vòng quay, khoá bấm) + aria-busy — trước đây nút đứng im không báo gì (handler theme bị chặn ở bước giữ submit).
    function optBusy(f, on) {
      try {
        var pf = f.closest ? f.closest("product-form") : null;
        if (pf) pf.classList[on ? "add" : "remove"]("m-spinner-loading");
        [].forEach.call(f.querySelectorAll("button[type='submit'], [name='add']"), function (b) {
          if (on) b.setAttribute("aria-busy", "true"); else b.removeAttribute("aria-busy");
          if (!pf && b.classList.contains("m-spinner-button")) b.classList[on ? "add" : "remove"]("m-spinner-loading");   // form không nằm trong <product-form>
        });
      } catch (e) {}
    }
    function waitPreviewThenSubmit(f, v) {
      if (f._r2pWaiting) return;
      f._r2pWaiting = true;
      if (OPT) optBusy(f, true);
      ensurePreviewNow(v);
      var waited = 0;
      var iv = setInterval(function () {
        waited += 150;
        var vNow = effectiveName();
        var match = canvasPrevUrl && canvasPrevKey === cartPrevKey(vNow);
        // R2 URL là ĐỦ: cart-transform function tự map R2->cdn.shopify.com (basename 1-1, fileCreate cùng request upload)
        // -> checkout vẫn có ảnh; hết cần ưu tiên chờ swap shopify -> add nhanh hơn ~1-2s. Trần cứng 4.5s (không chặn bán).
        var ready = match;
        if (ready || waited >= 4500) {
          clearInterval(iv); f._r2pWaiting = false;
          syncHidden();
          if (OPT) optBusy(f, false);   // T-02: trả nút NGAY trước requestSubmit — handler theme bật lại spinner của nó trong cùng nhịp (không nháy)
          f._r2pPass = true;
          if (f.requestSubmit) f.requestSubmit(); else f.submit();
          setTimeout(function () { f._r2pPass = false; }, 800);
        }
      }, 150);
    }
    // CHUẨN BỊ NGẦM _preview khi gõ tên/đổi font-màu (debounce) -> add-to-cart TRỰC TIẾP (không mở modal) vẫn có ảnh trong cart/checkout.
    var _bgT = null;
    function schedBgPreview() {
      if (!CANVAS) return;
      clearTimeout(_bgT);
      _bgT = setTimeout(function () {
        var v = effectiveName(); if (!v && !OPT) return;   // 15/10: OPT -> trống vẫn làm mới lớp phủ gallery (design không tên)
        if (window.__r2pGalleryRefresh) window.__r2pGalleryRefresh(currentColor);   // lớp phủ gallery đang bật -> cập nhật design mới (tên/font/design đổi)
        if (OPT) updateStickyThumb();   // audit T-03: tên / font / design đổi -> thumb sticky theo combo mới (xoá tên thì không giữ ảnh tên cũ)
        if (!v) return;   // 15/10 (review): OPT + trống -> KHÔNG render+upload ngầm: ảnh không tên giống nhau cho mọi khách, mỗi lần đổi màu/font = 1 R2 put + fileCreate (chung hạn mức 5000/ngày + 20/phút/IP với upload thật lúc thêm giỏ). _preview không tên do modal (modalAfter) + thêm giỏ (waitPreviewThenSubmit -> ensurePreviewNow('')) lo
        logName("settle");
        if (canvasPrevKey === cartPrevKey(v) && canvasPrevUrl) return;   // combo này đã có
        if (modal && !modal.hidden) return;   // modal đang mở -> paintModal đã lo
        doCanvasRender(v, curFont, curLayout, function (res) { if (!res) return; uploadCartPreview(res, v); if (res.url && res.url.indexOf("blob:") === 0) { var _u = res.url; setTimeout(function () { if (_u !== overEl._ou) { try { URL.revokeObjectURL(_u); } catch (e) {} } }, 0); } });   // HOÃN revoke + BỎ QUA nếu blob đang là overlay (chống race gộp bgAfter+modalAfter revoke nhầm blob modal)
      }, 400);
    }
    // after cho preview MODAL: lỗi (res=null) -> tự RETRY 1 lần (cache engine đã xoá entry hỏng nên retry là fetch thật);
    // fail lần 2 -> tắt spinner + báo lỗi rõ (hết cảnh xoay vô hạn phải tắt bật preview).
    var _mRetried = false, _ovHeal = 0;
    function modalAfter(v) {
      return function (res) {
        if (!res) {
          if (!_mRetried) {
            _mRetried = true;
            setTimeout(function () { var vn = effectiveName(); if ((vn || OPT) && modal && !modal.hidden) doCanvasRender(vn, curFont, curLayout, modalAfter(vn)); }, 400);   // 15/10: OPT -> retry cả bản không tên
            return;
          }
          showSpin(false);
          noteEl.textContent = "⚠️ Vorschau konnte gerade nicht geladen werden – bitte kurz erneut versuchen.";
          noteEl.hidden = false;
          return;
        }
        _mRetried = false;
        showSpin(false); applyCanvasPlace(res); setOverlay(res.url); uploadCartPreview(res, v);
      };
    }
    // 15/10 (review) CHỈ OPT: render stale mà TÊN đã đổi (vd 'Lena' -> trống) -> after cũ là closure TÊN CŨ (bg / modalAfter / composeOnColor):
    // chạy lại = uploadCartPreview(ảnh mới, tên cũ) -> 1 R2 put + fileCreate phí + thumb sticky gắn sai key. Thay bằng after này: modal đang mở ->
    // modalAfter(tên HIỆN TẠI) (overlay + upload đúng key); modal đóng -> chỉ dọn blob. Lớp phủ gallery + _preview nền: schedBgPreview (luôn chạy sau khi gõ) lo.
    function optReAfter(vn) {
      return function (res) {
        if (modal && !modal.hidden) { modalAfter(vn)(res); return; }
        if (res && res.url && res.url.indexOf("blob:") === 0) { var _ru = res.url; setTimeout(function () { if (_ru !== overEl._ou) { try { URL.revokeObjectURL(_ru); } catch (e) {} } }, 0); }
      };
    }
    function paintModal() {
      var v = effectiveName(); var slug = slugify(v);
      updateVariantSummary();
      _mRetried = false; _ovHeal = 0;   // mỗi lần vẽ modal được quyền retry mới
      if (zModal) zModal.reset();   // preview mới -> về 1×
      capEl.hidden = true; capEl.textContent = "";
      noteEl.hidden = true;
      if (addNameEl) addNameEl.style.display = v ? "none" : "block";   // audit T-05 (OPT): trống -> hiện nút «✏️ Namen hinzufügen»
      overEl.style.visibility = "hidden"; overEl.removeAttribute("src"); showSpin(false);
      overEl.style.top = pa.top + "%"; overEl.style.left = pa.left + "%"; overEl.style.width = pa.width + "%"; overEl.style.height = pa.height + "%";   // reset box; canvas sẽ override qua applyCanvasPlace
      if (TPL.preview) {                              // dynamic R2
        if (previewable(slug)) { mockEl.src = previewUrl(); }   // preset: ảnh ghép design + tên
        else {                                                  // tên riêng
          if (window.PodifyCanvas) {   // PODIFY: canvas (v2 lazy-load) phủ design lên áo PHÔI TRỐNG
            mockEl.src = mockUrl(currentColor);                     // {base}/mockups/{garment}/{color}.webp (không có DEINNAME)
            showSpin(true);
            doCanvasRender(v, curFont, curLayout, modalAfter(v));   // căn V1 + up _preview + retry khi lỗi
            noteEl.textContent = IS_AGE ? "✨ Sofort-Vorschau – so wird dein Design mit „" + v + "“ gestaltet." : "✨ Sofort-Vorschau deines Namens „" + v + "“ – so wird dein Design gestaltet.";
            if (OPT && !v) noteEl.textContent = OPT_NOTE;   // 15/10: tên không bắt buộc, trống -> xem trước KHÔNG tên
          } else {
            mockEl.src = galleryUrl(currentColor);
            noteEl.textContent = "ℹ Vorschau zeigt nur das Farb-Bild. Dein Name „" + v + "“ wird individuell gestaltet.";
          }
          noteEl.hidden = false;
        }
      } else {                                        // demo: mockup + overlay 2 lớp
        mockEl.src = mockUrl(currentColor);
        if (hasOverlay(slug)) { overEl.src = overlayUrl(slug); }
        else if (window.PodifyCanvas) {   // PODIFY: canvas (v2 lazy-load) preview cho tên custom
          showSpin(true);
          doCanvasRender(v, curFont, curLayout, modalAfter(v));
          noteEl.textContent = indivNote(v); noteEl.hidden = false;
          if (OPT && !v) noteEl.textContent = OPT_NOTE;   // 15/10: như trên (nhánh không có TPL.preview)
        }
        else { capEl.textContent = v; capEl.hidden = false; noteEl.textContent = indivNote(v); noteEl.hidden = false; }
      }
    }
    // ===== thumbnail THANH STICKY footer: mặc định = lớp phủ DEINNAME theo màu (tối→đen, sáng→trắng);
    //        sau khi khách bấm "Vorschau ansehen" = ảnh preview của khách (tên + màu) =====
    var previewed = false;
    var _stOrig = null;   // 15/10 audit T-03 (OPT): src gốc thumb sticky — xem stickyOrig()
    function stickyThumbUrl() {
      var v = effectiveName(), s = slugify(v);
      if (previewed && v && TPL.preview && previewable(s)) return previewUrl();  // preview khách (tên có sẵn)
      if (previewed && (v || OPT) && canvasStickyUrl && canvasStickyKey === cartPrevKey(v)) return canvasStickyUrl;   // tên CUSTOM: ảnh canvas vừa ghép (đúng combo); 15/10: OPT trống -> ảnh ghép không tên
      if (OPT) {   // 15/10 audit T-03 (CHỈ OPT): KHÔNG thay bằng áo trơn (galleryUrl) — design chính là SP. Ảnh ghép đúng combo hiện tại
        // (ảnh tải lên nền / lớp phủ gallery khi đổi màu) nếu đã có, không thì ảnh gốc của thumb = ảnh đại diện SP (design trải phẳng)
        if (canvasStickyUrl && canvasStickyKey === cartPrevKey(v)) return canvasStickyUrl;
        return _colorPrevCache[currentColor + "|" + v + "|" + curFont + "|" + curLayout + keyX()] || stickyOrig();   // 01/11 📷 photo3: + keyX (V2: "")
      }
      return galleryUrl(currentColor);   // mặc định / tên riêng = ảnh màu DEINNAME theo màu đang chọn
    }
    function stickyOrig() {   // OPT: src GỐC của thumb sticky (theme render = ảnh đại diện SP), đọc 1 lần trước lần thay đầu tiên
      if (_stOrig == null) { var im = document.querySelector(".m-sticky-addtocart--image img"); _stOrig = (im && im.getAttribute("src")) || ""; }
      return _stOrig;
    }
    function updateStickyThumb() {
      var u = stickyThumbUrl(); if (!u) return;
      document.querySelectorAll(".m-sticky-addtocart--image img").forEach(function (img) {
        img.removeAttribute("srcset"); img.removeAttribute("data-src"); img.src = u;
      });
    }
    function openModal() {
      var v = effectiveName();
      if (!v && !OPT) { warn(MSG_EMPTY); input.focus(); return; }   // 15/10: OPT -> trống vẫn mở xem trước (bản không tên)
      if (modal.hidden) {   // T-09: nhớ NÚT đã mở hộp (nút xem trước trong khối / nút 👁 thanh dính) để trả con trỏ khi đóng — CHỈ khi nút đó đang giữ con trỏ
        // (mở bằng bàn phím, hoặc Chrome đặt con trỏ vào nút khi bấm). Safari / mọi trình duyệt iOS: bấm/chạm nút KHÔNG đặt con trỏ vào nút ->
        // activeElement có thể là ô tên -> trả con trỏ về đó = bật lại bàn phím điện thoại + nhảy trang mỗi lần đóng hộp. Không phải nút mở -> không trả.
        var _a = document.activeElement;
        _mRet = (_a && _a === previewBtn) ? _a : ((_a && _a.closest && _a.closest("[data-sticky-preview]")) || null);
      }
      paintModal();
      previewed = true; updateStickyThumb(); logName("preview");
      if (window.__r2pGalleryShow) window.__r2pGalleryShow(currentColor);   // phủ design lên gallery cho MÀU ĐANG chọn (khỏi phải đổi màu mới thấy)
      modal.hidden = false; modal.style.display = "flex"; document.body.style.overflow = "hidden";
      if (mClose) { try { mClose.focus({ preventScroll: true }); } catch (e) {} }   // T-09: con trỏ bàn phím vào hộp (nút ✕)
    }
    function closeModal() { modal.hidden = true; modal.style.display = "none"; document.body.style.overflow = ""; if (zModal) zModal.reset(); }
    function warn(msg) { status.classList.remove("r2p--ok", "r2p--info"); status.textContent = "⚠ " + msg; status.classList.add("r2p--warn"); }
    // ===== 15/10 audit T-09 (a11y, MỌI SP): hộp xem trước là hộp thoại thật — Esc đóng; mở -> con trỏ bàn phím vào nút ✕; Tab / Shift+Tab xoay vòng
    // trong hộp; đóng bằng ✕ / nền tối / Esc -> trả con trỏ về nút đã mở nếu lúc mở nút đó giữ con trỏ — xem openModal (đóng do thêm giỏ xong / nút khác: không đụng con trỏ, giỏ trượt tự lo).
    // Tiêu đề hộp có id + aria-labelledby (cả markup V2 lẫn V3). Màn hình phóng ảnh đang mở -> Esc / Tab để nó tự xử lý.
    var mCard = modal.querySelector(".r2p__card"), mClose = modal.querySelector(".r2p__close"), _mRet = null;
    try {
      var _mTitle = modal.querySelector(".r2p__title");
      if (mCard && _mTitle && !mCard.getAttribute("aria-labelledby")) { if (!_mTitle.id) _mTitle.id = "r2p-title-" + (input.id || "0"); mCard.setAttribute("aria-labelledby", _mTitle.id); }
    } catch (e) {}
    function dismissModal() {
      closeModal();
      var r = _mRet; _mRet = null;
      if (r && r.focus && r !== document.body && document.contains(r)) { try { r.focus({ preventScroll: true }); } catch (e) {} }
    }
    function mFocusables() {
      return [].filter.call(mCard.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"), function (el) {
        if (el.disabled || el.hidden) return false;
        var cs = getComputedStyle(el); return cs.display !== "none" && cs.visibility !== "hidden";
      });
    }
    document.addEventListener("keydown", function (e) {
      if (modal.hidden || document.querySelector(".r2p__zoomwrap")) return;
      if (e.key === "Escape" || e.key === "Esc") { e.preventDefault(); dismissModal(); return; }
      if (e.key !== "Tab" || !mCard) return;
      var fs = mFocusables(); if (!fs.length) return;
      var a = document.activeElement, first = fs[0], last = fs[fs.length - 1];
      if (!mCard.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });

    previewBtn.addEventListener("click", openModal);
    modal.querySelectorAll("[data-r2p-close]").forEach(function (c) { c.addEventListener("click", dismissModal); });   // T-09: đóng chủ động -> trả con trỏ
    // 04/10: ZOOM SÂU — con lăn chuột phóng/thu ĐÚNG CHỖ con trỏ (tới 6×) + kéo để di chuyển, cả trong modal lẫn màn hình
    // phóng to; màn hình phóng to thêm chụm 2 ngón (mobile) và bấm ảnh = phóng 2,5× / về 1×. Mockup + tên + customcap gói
    // chung 1 lớp .r2p__zl để phóng cùng nhau (spinner, nút 🔍, nhãn % nằm ngoài nên không bị phóng).
    var ZMAX = 6, NOHOVER = !!(window.matchMedia && matchMedia("(hover: none)").matches), HAS_TOUCH = "ontouchstart" in window;
    function zoomLayer(st) {
      var zl = st.querySelector(".r2p__zl");
      if (zl) return zl;
      zl = document.createElement("div"); zl.className = "r2p__zl";
      [].slice.call(st.children).forEach(function (ch) {
        if (ch.matches && ch.matches("[data-r2p-mockup],[data-r2p-overlay],[data-r2p-customcap]")) { if (ch.tagName === "IMG") ch.draggable = false; zl.appendChild(ch); }
      });
      st.insertBefore(zl, st.firstChild);
      return zl;
    }
    // opt.touch = màn hình phóng to (chụm 2 ngón, chặn menu giữ-lâu); opt.host = phần tử NHẬN sự kiện (mặc định st;
    // màn hình phóng to dùng cả nền tối -> chụm/lăn chỗ nào cũng được). Toạ độ luôn tính theo st.
    function attachZoom(st, opt) {
      opt = opt || {};
      var host = opt.host || st, zl = zoomLayer(st), s = 1, tx = 0, ty = 0, badge = null, bT = 0, ptrs = {}, drag = null, pinch = null, moved = false;
      var lastType = "mouse", lastWheel = 0, lastTap = 0, lastW = 0, g0 = 1;
      function dims() { return { w: st.clientWidth || 1, h: st.clientHeight || 1 }; }
      function apply(showBadge) {
        if (s <= 1.001) { s = 1; tx = 0; ty = 0; }
        var d = dims(); lastW = d.w;   // không cho kéo lộ nền ra ngoài ảnh
        tx = Math.min(0, Math.max(d.w - d.w * s, tx)); ty = Math.min(0, Math.max(d.h - d.h * s, ty));
        zl.style.transform = s === 1 ? "" : "translate(" + tx + "px," + ty + "px) scale(" + s + ")";
        st.classList.toggle("r2p--zoomed", s > 1);
        if (showBadge) {
          if (!badge) { badge = document.createElement("span"); badge.className = "r2p__zlevel"; st.appendChild(badge); }
          badge.textContent = Math.round(s * 100) + "%"; badge.style.opacity = "1";
          clearTimeout(bT); bT = setTimeout(function () { if (badge) badge.style.opacity = "0"; }, 1100);
        }
      }
      function rebase() { var k = Object.keys(ptrs)[0]; if (drag && k) drag = { x: ptrs[k].x, y: ptrs[k].y, tx: tx, ty: ty }; }   // đang giữ chuột kéo mà lăn/bấm zoom -> kéo tiếp từ vị trí MỚI, không giật về
      function zoomAt(ns, px, py) {   // giữ nguyên điểm ảnh nằm dưới (px,py) khi đổi tỉ lệ
        ns = Math.max(1, Math.min(ZMAX, ns));
        if (Math.abs(ns - s) < 1e-4) return;
        tx = px - (px - tx) * (ns / s); ty = py - (py - ty) * (ns / s); s = ns; apply(true); rebase();
      }
      function local(e) { var r = st.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
      host.addEventListener("wheel", function (e) {
        var dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? 400 : 1);
        if (!dy || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;   // vuốt ngang / delta 0: để trình duyệt (back-swipe, cuộn ngang)
        if (s <= 1 && !e.ctrlKey) {
          if (dy > 0) return;   // đang 1× mà lăn xuống -> modal/trang cuộn bình thường (không kẹt cuộn trên ảnh)
          var card = st.closest && st.closest(".r2p__card");   // card đang cuộn xuống -> lăn lên thì cuộn card trước, ảnh lộ hết mới zoom
          if (card && card.scrollTop > 0 && st.getBoundingClientRect().top < card.getBoundingClientRect().top) return;
        }
        e.preventDefault();   // gồm Ctrl+lăn / chụm touchpad (ctrlKey): không để trình duyệt zoom cả trang
        var now = Date.now(), gap = now - lastWheel; lastWheel = now;
        var mag = Math.min(0.66, Math.abs(dy) * (e.ctrlKey ? 0.01 : 0.0022));   // 1 nấc chuột Windows (deltaY 100) ≈ ×1,25 -> ~8 nấc tới 6×
        if (!e.ctrlKey && gap > 30) mag = Math.max(mag, 0.1);   // nấc chuột rời (macOS chỉ báo vài px/nấc) vẫn phóng ≥10%; touchpad (sự kiện dày) giữ tỉ lệ thật
        var p = local(e); zoomAt(s * Math.exp(dy < 0 ? mag : -mag), p.x, p.y);
      }, { passive: false });
      if (!HAS_TOUCH) {   // Safari macOS: chụm touchpad là gesture event (không phải ctrl+wheel)
        host.addEventListener("gesturestart", function (e) { e.preventDefault(); g0 = s; });
        host.addEventListener("gesturechange", function (e) { e.preventDefault(); var p = local(e); zoomAt(g0 * e.scale, p.x, p.y); });
      }
      host.addEventListener("dragstart", function (e) { e.preventDefault(); });   // chặn trình duyệt tự "kéo file ảnh" (cướp mất thao tác kéo)
      if (opt.touch) host.addEventListener("contextmenu", function (e) { if (lastType !== "mouse") e.preventDefault(); });   // giữ lâu ngón tay không bật menu "Lưu ảnh"
      host.addEventListener("pointerdown", function (e) {
        lastType = e.pointerType || "mouse";
        if (e.pointerType === "mouse" && e.button !== 0) return;
        ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(ptrs);
        if (ids.length === 2 && opt.touch) {   // chụm 2 ngón: nhớ khoảng cách + tâm ban đầu
          var a = ptrs[ids[0]], b = ptrs[ids[1]], r = st.getBoundingClientRect();
          pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: s, cx: (a.x + b.x) / 2 - r.left, cy: (a.y + b.y) / 2 - r.top, tx: tx, ty: ty };
          drag = null; moved = true;
        } else if (ids.length === 1) { drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty }; moved = false; }
        if (s > 1 || opt.touch) { try { host.setPointerCapture(e.pointerId); } catch (er) {} }
      });
      host.addEventListener("pointermove", function (e) {
        if (!ptrs[e.pointerId]) return;
        if (e.pointerType === "mouse" && !(e.buttons & 1)) { up(e); return; }   // nhả chuột ngoài khung (không nhận pointerup) -> xoá trạng thái kéo cũ
        ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (pinch) {
          var ids = Object.keys(ptrs); if (ids.length < 2) return;
          var a = ptrs[ids[0]], b = ptrs[ids[1]], r = st.getBoundingClientRect();
          var ns = Math.max(1, Math.min(ZMAX, pinch.s * (Math.hypot(a.x - b.x, a.y - b.y) / pinch.d)));
          var mx = (a.x + b.x) / 2 - r.left, my = (a.y + b.y) / 2 - r.top;
          tx = mx - (pinch.cx - pinch.tx) * (ns / pinch.s); ty = my - (pinch.cy - pinch.ty) * (ns / pinch.s); s = ns; apply(true);
          return;
        }
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y, mouse = e.pointerType === "mouse";
        // ngón tay rung nhẹ khi chạm (≤12px) KHÔNG tính là kéo; ở 1× chạm tay không kéo được gì nên không bao giờ nuốt cú chạm
        if (Math.abs(dx) + Math.abs(dy) > (mouse ? 4 : 12) && (s > 1 || mouse)) moved = true;
        if (s > 1 && moved) { tx = drag.tx + dx; ty = drag.ty + dy; apply(false); }
      });
      function up(e) {
        delete ptrs[e.pointerId];
        var ids = Object.keys(ptrs);
        if (ids.length < 2) pinch = null;
        drag = ids.length === 1 ? { x: ptrs[ids[0]].x, y: ptrs[ids[0]].y, tx: tx, ty: ty } : null;   // nhấc 1 ngón sau pinch -> ngón còn lại kéo tiếp
      }
      host.addEventListener("pointerup", up); host.addEventListener("pointercancel", up);
      // vừa kéo/chụm xong thì cú click đi kèm KHÔNG được tính là bấm (không mở/đóng/phóng nhầm)
      host.addEventListener("click", function (e) { if (moved) { moved = false; e.stopImmediatePropagation(); e.preventDefault(); } }, true);
      // xoay máy / đổi cỡ cửa sổ khi đang zoom: giữ đúng vùng đang xem theo tỉ lệ, không để lộ khoảng trống
      if (window.ResizeObserver) new ResizeObserver(function () {
        var d = dims(); if (!lastW || d.w === lastW) return;
        if (s > 1) { tx *= d.w / lastW; ty *= d.w / lastW; apply(false); } else lastW = d.w;
      }).observe(st);
      return {
        reset: function () { s = 1; apply(false); },
        state: function () { var d = dims(); return { s: s, rx: tx / d.w, ry: ty / d.h }; },
        set: function (ns, rx, ry) { var d = dims(); s = Math.max(1, Math.min(ZMAX, ns)); tx = rx * d.w; ty = ry * d.h; apply(false); },
        toggleAt: function (e) {
          if (lastType !== "mouse") { var now = Date.now(); if (now - lastTap < 350) return; lastTap = now; }   // chạm đúp: chỉ phóng 1 lần, không phóng rồi thu ngay
          var p = local(e); if (s > 1) { s = 1; apply(true); } else zoomAt(2.5, p.x, p.y); rebase();
        }
      };
    }
    // Bấm ảnh preview -> phóng to fullscreen (clone stage: giữ nguyên mockup + overlay tên + customcap đúng vị trí, giữ luôn mức zoom đang xem)
    var stage = modal.querySelector("[data-r2p-stage]");
    if (stage) {
      zModal = attachZoom(stage, { touch: false });
      if (!NOHOVER) stage.title = "Klicken zum Vergrößern · Mausrad = Zoom";
      stage.addEventListener("click", function () {
        var z = document.createElement("div"); z.className = "r2p__zoomwrap";
        var clone = stage.cloneNode(true); clone.removeAttribute("title");
        var ob = clone.querySelector(".r2p__zlevel"); if (ob) ob.remove();
        var x = document.createElement("button"); x.type = "button"; x.className = "r2p__zoomx"; x.setAttribute("aria-label", "Schließen"); x.textContent = "✕";
        var help = document.createElement("div"); help.className = "r2p__zhelp";
        help.textContent = NOHOVER ? "Mit 2 Fingern zoomen · Ziehen zum Verschieben" : "Mausrad = Zoom · Ziehen zum Verschieben · Klick = 2,5× / zurück";
        z.appendChild(clone); z.appendChild(x); z.appendChild(help);
        function closeZ() { z.remove(); document.removeEventListener("keydown", escZ); }
        function escZ(ev) { if (ev.key === "Escape") { ev.stopPropagation(); closeZ(); } }
        document.addEventListener("keydown", escZ);
        if (HAS_TOUCH) z.addEventListener("gesturestart", function (ev) { ev.preventDefault(); });   // iOS: chụm không zoom cả trang
        document.body.appendChild(z);
        var zf = attachZoom(clone, { touch: true, host: z });   // nhận cử chỉ trên CẢ nền tối, toạ độ theo ảnh
        // bấm trong ẢNH = phóng 2,5× / về 1×; ngoài ảnh (nền tối) hoặc ✕ = đóng. Xét theo toạ độ, không theo target
        // (khi đang giữ pointer capture, click có thể rơi vào nền dù bấm trên ảnh).
        z.addEventListener("click", function (ev) {
          if (ev.target === x) { closeZ(); return; }
          var r = clone.getBoundingClientRect();
          if (ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom) zf.toggleAt(ev); else closeZ();
        });
        var st0 = zModal.state(); zf.set(st0.s, st0.rx, st0.ry);   // đang zoom trong modal -> mở fullscreen đúng chỗ đó
        setTimeout(function () { help.classList.add("r2p__zhelp--fade"); }, 3500);
      });
    }
    addBtn.addEventListener("click", function () {
      syncHidden();
      if (!effectiveName() && !OPT) { closeModal(); warn(MSG_EMPTY); input.focus(); return; }   // 15/10: OPT -> trống vẫn thêm giỏ
      if (addBtn._busy) return;   // chống double-tap
      var atc = document.querySelector("form[action*='/cart/add'] [name='add'], form[action*='/cart/add'] button[type='submit'], product-form [type='submit']");
      if (!atc && !cartForm) { closeModal(); return; }
      // 25/08 UX: GIỮ modal + spinner trên nút thay vì đóng ngay rồi im lặng 2-5s (chờ upload _preview + AJAX drawer).
      // Xong thật (item_count tăng qua /cart.js) hoặc quá 9s -> trả nút + đóng modal (KHÔNG bao giờ kẹt spinner).
      addBtn._busy = 1;
      var oldHtml = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.innerHTML = '<span class="r2p__btnspin" aria-hidden="true"></span>Wird hinzugefügt…';
      var done = function () {
        if (!addBtn._busy) return;
        addBtn._busy = 0;
        addBtn.disabled = false;
        addBtn.innerHTML = oldHtml;
        closeModal();
      };
      var fire = function (base) {
        if (atc) atc.click();
        else { cartForm.requestSubmit ? cartForm.requestSubmit() : cartForm.submit(); }
        var n = 0;
        var iv = setInterval(function () {
          n++;
          fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
            if (base >= 0 && (c.item_count || 0) > base) { clearInterval(iv); done(); }
            else if (n >= 18) { clearInterval(iv); done(); }
          }).catch(function () { if (n >= 18) { clearInterval(iv); done(); } });
        }, 500);
      };
      // đọc SỐ LƯỢNG GIỎ TRƯỚC khi bắn submit (đo "đã vào giỏ" = item_count tăng); lỗi mạng -> vẫn bắn, chỉ còn fallback 9s
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { fire(c.item_count || 0); }).catch(function () { fire(-1); });
    });

    // dynamic: nạp danh sách tên có preview từ R2 (names.json) — thêm tên = upload json, không sửa theme
    // V2 canvas: NGẮT HẲN CDN 500 tên — không fetch names.json (không gợi ý, không preset, mọi tên render canvas)
    if (TPL.names && !CANVAS) {
      try {
        var nurl = fill(TPL.names, "", ""); nurl += (nurl.indexOf("?") < 0 ? "?" : "&") + "t=" + Date.now();
        fetch(nurl, { mode: "cors", cache: "no-store" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (arr) { if (arr && arr.length) { names = arr; rebuildSlugs(); syncHidden(); } })
          .catch(function () {});
      } catch (e) {}
    }

    currentColor = readColor() || slugify(cfg.defaultColor || "schwarz");
    updatePickerBg();
    syncHidden();
    updateStickyThumb(); setTimeout(updateStickyThumb, 700);   // sticky thumb có thể render trễ
  }
})();

/* Sắp xếp lại thứ tự nút SIZE — 17/10: thứ tự ĐÚNG đã render từ Liquid (snippets/option-value-order.liquid), khối này chỉ là lưới an toàn:
   CÙNG bảng thứ tự với Liquid (thêm xxs/xxl/xxxl/6xl), KHÔNG đụng option có <select> (trước đây appendChild kéo <option> ra khỏi <select>),
   chỉ appendChild khi thứ tự thật sự lệch (không làm DOM nhảy vô ích). Không đụng giá trị/variant. */
(function () {
  var ORDER = ["xxs", "xs", "s", "m", "l", "xl", "2xl", "xxl", "3xl", "xxxl", "4xl", "5xl", "6xl"];
  function rank(t) { var i = ORDER.indexOf((t || "").replace(/\s+/g, "").toLowerCase()); return i < 0 ? 999 : i; }
  function sortSizes() {
    document.querySelectorAll(".m-product-option").forEach(function (opt) {
      var lbl = opt.querySelector(".option-label--title");
      var name = (lbl ? lbl.textContent : "").toLowerCase();
      if (name.indexOf("größe") < 0 && name.indexOf("grösse") < 0 && name.indexOf("groesse") < 0 && name.indexOf("grosse") < 0 && name.indexOf("size") < 0) return;
      var wrap = opt.querySelector(".m-product-option--content");
      if (!wrap || wrap.querySelector("select")) return;
      var nodes = [].slice.call(wrap.children).filter(function (n) { return n.classList.contains("m-product-option--node"); });
      if (nodes.length < 2) return;
      var sorted = nodes.slice().sort(function (a, b) { return rank(a.getAttribute("data-value")) - rank(b.getAttribute("data-value")); });
      if (sorted.some(function (n, i) { return n !== nodes[i]; })) sorted.forEach(function (n) { wrap.appendChild(n); });
    });
  }
  if (document.readyState !== "loading") sortSizes();
  else document.addEventListener("DOMContentLoaded", sortSizes);
  setTimeout(sortSizes, 800);   // chạy lại phòng variant-picker render trễ
})();

/* ĐỔI SIZE/MÀU CLIENT-SIDE — bỏ cú fetch Section-Rendering của Minimog (nguyên nhân "load").
   SP personalized có giá đồng nhất + luôn còn hàng nên fetch lại là vô ích.
   Tự cập nhật: nhãn đã-chọn + input variant + URL + ảnh gallery (dùng hàm có sẵn của theme).
   AN TOÀN: không khớp variant -> KHÔNG chặn -> để Minimog chạy mặc định (fallback). */
(function () {
  var holder = document.querySelector("[data-r2p-variants]");
  if (!holder) return;
  var LIST;
  try { LIST = JSON.parse(holder.textContent); } catch (e) { return; }
  if (!LIST || !LIST.length) return;
  function slugify(s) { return (s || "").toLowerCase().trim().replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); }
  function key(a, b, c) { return [a == null ? "" : a, b == null ? "" : b, c == null ? "" : c].join(""); }
  var BY = {};
  LIST.forEach(function (v) { BY[key(v.o1, v.o2, v.o3)] = v; });
  // 13/08: vị trí option Farbe ĐỘNG (cfg.colorPos từ liquid) — t-shirt legacy = 1, phôi registry (Farbe/Größe) = 0
  var CPOS = 1;
  try { var _c0 = document.querySelector("[data-r2p-config]"); if (_c0) { var _cj = JSON.parse(_c0.textContent); if (typeof _cj.colorPos === "number") CPOS = _cj.colorPos; } } catch (e) {}
  var COLOR_MEDIA = {};
  LIST.forEach(function (v) { if (v.fm) COLOR_MEDIA[String(v.fm.id)] = true; });   // id 5 ảnh màu -> ẩn khỏi gallery

  function selectedVals(picker) {
    var vals = [];
    picker.querySelectorAll(".m-product-option").forEach(function (opt) {
      var ck = opt.querySelector(".m-product-option__input:checked");
      var sel = opt.querySelector("select");
      vals.push(ck ? ck.value : (sel ? sel.value : ""));
    });
    return vals;
  }
  function syncLabels(picker) {
    picker.querySelectorAll(".m-product-option").forEach(function (opt) {
      var ck = opt.querySelector(".m-product-option__input:checked");
      var sel = opt.querySelector("select");
      var lbl = opt.querySelector(".option-label--selected");
      if (lbl) lbl.textContent = ck ? ck.value : (sel ? sel.value : "");
    });
  }

  // Ẩn 5 ảnh màu khỏi gallery + dựng lớp phủ thiết kế-theo-màu (hiện khi khách bấm màu).
  function setupGallery(pi) {
    var gallery = document.getElementById("MediaGallery-" + pi.dataset.sectionId) || pi.querySelector(".m-media-gallery");
    var pm = pi.querySelector("product-media");
    var colorImages = {};
    try { colorImages = (JSON.parse(pi.querySelector("[data-r2p-config]").textContent).colorImages) || {}; } catch (e) {}
    var isSlider = !!(gallery && gallery.querySelector(".m-product-media--slider"));
    function mainSwiper() { var el = gallery && (gallery.querySelector(".m-media-gallery__inner.swiper-container") || gallery.querySelector(".m-media-gallery__inner.swiper") || gallery.querySelector(".m-media-gallery__inner") || gallery.querySelector(".swiper-container") || gallery.querySelector(".swiper")); return el && el.swiper; }
    var swDone = false;
    function removeFromSwiper() {
      if (swDone) return;
      var sw = mainSwiper();
      if (!sw || !sw.removeSlide) return;                 // Swiper chưa init -> để retry
      var loop = sw.params && sw.params.loop;
      try { if (loop && sw.loopDestroy) sw.loopDestroy(); } catch (e) {}
      var idx = [], sl = sw.slides || [];
      for (var i = 0; i < sl.length; i++) { if (sl[i] && COLOR_MEDIA[String(sl[i].getAttribute("data-media-id"))]) idx.push(i); }
      if (idx.length) { try { sw.removeSlide(idx); } catch (e) {} }
      try { if (loop && sw.loopCreate) sw.loopCreate(); sw.update(); sw.slideTo(0, 0); } catch (e) {}
      swDone = true;
    }
    function hideColor() {
      if (!gallery) return;
      if (isSlider) {
        // KHÔNG đụng slider chính (Swiper loop vỡ nếu xoá/ẩn slide). Chỉ ẩn THUMBNAIL màu -> gallery sạch.
        // Slide màu chính vẫn còn nhưng không điều hướng tới (thumbnail ẩn + interceptor không auto-scroll); lớp phủ lo phần xem màu.
        gallery.querySelectorAll(".m-product-media--slider__thumbnails [data-media-id]").forEach(function (el) { if (COLOR_MEDIA[String(el.getAttribute("data-media-id"))]) el.style.display = "none"; });
      } else {
        gallery.querySelectorAll("[data-media-id]").forEach(function (el) { if (COLOR_MEDIA[String(el.getAttribute("data-media-id"))]) el.style.display = "none"; });
      }
    }
    hideColor();
    [200, 500, 1000, 1800, 2800].forEach(function (t) { setTimeout(hideColor, t); });
    var host = gallery && (gallery.querySelector(".m-media-gallery__inner") || gallery.querySelector(".m-media-gallery__wrapper") || gallery);
    if (!host) return null;
    if (getComputedStyle(host).position === "static") host.style.position = "relative";
    var ov = document.createElement("div"); ov.className = "r2p-coverlay";
    var img = document.createElement("img"); img.alt = ""; img.decoding = "async";
    var x = document.createElement("button"); x.type = "button"; x.className = "r2p-coverlay__x"; x.setAttribute("aria-label", "Schließen"); x.textContent = "✕";
    ov.appendChild(img); ov.appendChild(x); host.appendChild(ov);
    var _showReq = null;
    function show(slug) {
      _showReq = slug;
      // V2 canvas: khách ĐÃ nhập tên -> ghép design tên THẬT lên phôi màu này (không hiện phôi trơn). Chưa nhập -> ảnh placeholder theo màu (V1/colorImages).
      if (window.__r2pColorPreview) {
        window.__r2pColorPreview(slug, function (dataUrl) {
          if (_showReq !== slug) return;   // đã đổi sang màu khác trong lúc render -> bỏ kết quả cũ
          if (dataUrl) { img.src = dataUrl; ov.classList.add("is-on"); return; }
          var u = colorImages[slug]; if (u) { img.src = u; ov.classList.add("is-on"); }   // fallback placeholder
        });
        return;
      }
      var u = colorImages[slug]; if (!u) return; img.src = u; ov.classList.add("is-on");
    }
    var _ie = false;   // 02/11 📷 photo4 R2: true khi r3-photo đang chỉnh ảnh khách NGAY TRÊN lớp phủ này (GL.edit) — không ẩn lớp phủ (vuốt / chạm / thumbnail). Trang V2: luôn false (y hệt cũ)
    function hide() { if (_ie) return; ov.classList.remove("is-on"); }
    ov.addEventListener("click", hide);
    x.addEventListener("click", function (e) { e.stopPropagation(); hide(); });
    setTimeout(function () { var msw = mainSwiper(); if (msw && msw.on) msw.on("slideChange", hide); }, 1200);
    if (gallery) gallery.addEventListener("click", function (e) { if (e.target.closest(".m-product-media--slider__thumbnails")) hide(); });
    // Cầu nối sang scope widget chính: gọi khi PREVIEW / gõ tên / đổi font-design để phủ design lên gallery cho MÀU ĐANG chọn
    // (không cần đổi màu). Chỉ refresh nếu lớp phủ đang bật HOẶC ép (force) — tránh tự bật khi khách chưa tương tác.
    window.__r2pGalleryRefresh = function (color, force) { if (!color) return; if (force || ov.classList.contains("is-on")) show(color); };
    window.__r2pGalleryShow = function (color) { if (color) show(color); };
    // 01/11 ⌨️ live-typing (CHỈ V3 — PodifyCanvas.v3.live của shim; trang V2 bỏ qua cả khối): canvas «bản sống» nằm TRÊN ảnh lớp phủ (khối LIVE trong init
    //   vẽ theo từng phím) + cờ: khách đang vuốt gallery / đã tự đóng lớp phủ (✕, chạm, vuốt, thumbnail -> không tự bật lại tới lần bấm ô tên sau) / lớp phủ trong màn hình.
    if (window.PodifyCanvas && window.PodifyCanvas.v3 && typeof window.PodifyCanvas.v3.live === "function") (function () {
      var lc = document.createElement("canvas"); lc.className = "r2p-coverlay__live"; lc.setAttribute("aria-hidden", "true");
      lc.style.cssText = "position:absolute;left:0;top:0;width:100%;height:100%;object-fit:contain;display:none;pointer-events:none";
      ov.insertBefore(lc, x);
      var touch = 0, swipeTill = 0, dismissed = false, vis = true;
      function tStart() { touch = Date.now(); }
      function tEnd() { if (touch) { touch = 0; swipeTill = Date.now() + 300; } }
      host.addEventListener("pointerdown", tStart, { capture: true, passive: true });
      host.addEventListener("touchstart", tStart, { capture: true, passive: true });
      ["pointerup", "pointercancel", "touchend", "touchcancel"].forEach(function (n) { window.addEventListener(n, tEnd, { capture: true, passive: true }); });
      setTimeout(function () { var sw = mainSwiper(); if (sw && sw.on) { sw.on("sliderMove", tStart); sw.on("touchEnd", tEnd); sw.on("slideChangeTransitionStart", function () { swipeTill = Date.now() + 500; }); } }, 1200);
      new MutationObserver(function () { if (!ov.classList.contains("is-on")) { dismissed = true; lc.style.display = "none"; } if (GL.chg) { try { GL.chg(); } catch (e) {} } }).observe(ov, { attributes: true, attributeFilter: ["class"] });
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
        var v = es[es.length - 1].isIntersecting, was = vis; vis = v;
        if (v && !was) { try { window.dispatchEvent(new Event("r2p:galvis")); } catch (e) {} }
      }, { threshold: 0.2 }).observe(host);
      var GL = window.__r2pGalleryLive = {
        ok: 1, canvas: lc, el: ov, img: img,   // el / img: thẻ xem trước mini (điện thoại) đo phần lớp phủ thấy được + chép ảnh ghép đủ cỡ
        imgOk: function () { return !!(img.getAttribute("src") && img.complete && img.naturalWidth); },
        on: function () { return ov.classList.contains("is-on"); },
        open: function () { ov.classList.add("is-on"); },
        canAuto: function () { return !dismissed && !(touch && Date.now() - touch < 2500) && Date.now() > swipeTill; },
        refocus: function () { dismissed = false; },
        vis: function () { return vis; },
        live: function (on) { lc.style.display = on ? "block" : "none"; },
        isLive: function () { return lc.style.display === "block"; },
        imgSrc: function () { return img.getAttribute("src") || ""; },
        decoded: function (fn) { var done = 0; function f() { if (!done) { done = 1; fn(); } } try { if (img.decode) { img.decode().then(f, f); return; } } catch (e) {} if (img.complete) f(); else { img.addEventListener("load", f, { once: true }); img.addEventListener("error", f, { once: true }); } },
        edit: function (on) { _ie = !!on; ov.classList.toggle("r2p-coverlay--edit", _ie); var sw = mainSwiper(); if (sw) { try { sw.allowTouchMove = !_ie; } catch (e) {} } if (_ie) { dismissed = false; ov.classList.add("is-on"); } },   // 02/11 📷 photo4 R2: khoá vuốt gallery + giữ lớp phủ khi khách chỉnh ảnh trên ảnh SP
        editing: function () { return _ie; }
      };
    })();
    return { show: show, hide: hide };
  }

  // Giá theo size (11/08: XS bỏ + phụ thu Übergröße) — format khớp shop: €30,95
  function fmtMoney(cents) { return "€" + (cents / 100).toFixed(2).replace(".", ","); }
  function syncPriceDom(pi, v) {
    try {
      var blocks = pi.querySelectorAll(".m-price");
      for (var i = 0; i < blocks.length; i++) {
        var el = blocks[i], money = fmtMoney(v.price);
        var s1 = el.querySelector(".m-price__sale .m-price-item--sale"); if (s1) s1.textContent = money;
        var s2 = el.querySelector(".m-price__regular .m-price-item--regular"); if (s2) s2.textContent = money;
        var cs = el.querySelector(".m-price__sale s.m-price-item--regular");
        if (cs && v.cap) cs.textContent = fmtMoney(v.cap);
        if (v.cap && v.cap > v.price) {
          el.classList.add("m-price--on-sale");
          var bd = el.querySelector(".m-price__badge-sale .m-product-tag");
          if (bd) bd.textContent = bd.textContent.replace(/\d+\s*%/, Math.round((v.cap - v.price) * 100 / v.cap) + "%");
        } else {
          // 26/08: đổi sang variant KHÔNG compare-at -> gỡ trạng thái sale (trước đây giá gạch/badge cũ DÍNH lại = hiển thị giảm giá giả)
          el.classList.remove("m-price--on-sale");
          if (cs) cs.textContent = "";
        }
      }
    } catch (e) { /* giá không sync được thì thôi — không chặn flow */ }
  }

  document.querySelectorAll("variant-picker").forEach(function (picker) {
    var pi = picker.closest("product-info");
    if (!pi || !pi.querySelector("[data-r2p]")) return;   // chỉ SP personalized
    var ovl = setupGallery(pi);
    var lastColor = null;
    try { lastColor = slugify(selectedVals(picker)[CPOS]); } catch (e) {}   // màu mặc định (KHÔNG show -> mặc định lifestyle)
    picker.addEventListener("change", function (e) {
      if (!e.isTrusted) return;   // chỉ xử lý click THẬT của khách; sự kiện tổng hợp (init/Minimog) để theme lo
      try {
        var vals = selectedVals(picker);
        var v = BY[key(vals[0], vals[1], vals[2])];
        if (!v) return;                                   // không khớp -> để Minimog fallback (KHÔNG stop)
        e.stopImmediatePropagation();                     // chặn emit -> chặn fetch
        var vo = { id: v.id, price: v.price, available: v.available, featured_media: v.fm ? { id: v.fm.id, position: v.fm.position } : null };
        syncLabels(picker);
        syncPriceDom(pi, v);   // giá/gạch/badge theo variant (size phụ thu 11/08) — trước đồng giá nên không cần
        if (typeof pi.updateVariantInputs === "function") pi.updateVariantInputs(v.id);
        if (typeof pi.updateURL === "function") pi.updateURL(pi.dataset.url, v.id);
        var col = slugify(vals[CPOS]);                    // vị trí Farbe động theo cfg.colorPos
        if (ovl && col && col !== lastColor) ovl.show(col);  // CHỈ show lớp phủ khi ĐỔI MÀU (đổi size giữ nguyên ảnh)
        lastColor = col;
        pi.currentVariant = vo;
        if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.variantChange, { data: { variant: vo, sectionId: pi.dataset.sectionId } });
        }
      } catch (err) { /* lỗi -> không chặn, Minimog xử lý như cũ */ }
    }, true);   // capture: chạy TRƯỚC listener bubble của variant-picker
  });
})();
// build 20260816-anchor-on
